"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftControllerListShiftsSortEnum = exports.ShiftControllerListShiftsShiftTypeEnum = exports.ShiftControllerListShiftsStatusEnum = exports.SearchControllerFindAvailableShiftsSortEnum = exports.SearchControllerFindAvailableOrientationOpportunitiesSortEnum = exports.ProfileControllerListProfilesSortEnum = exports.ProfileControllerListProfilesFilterModeEnum = exports.PayrollControllerGetPaychecksStatusEnum = exports.OrientationOpportunityControllerListOrientationOpportunitiesSortEnum = exports.NurseControllerListShiftsSortEnum = exports.FacilityControllerShiftCalendarSortEnum = exports.FacilityControllerListShiftsSortEnum = exports.FacilityControllerListShiftsShiftTypeEnum = exports.FacilityControllerListShiftsShiftTimesEnum = exports.FacilityControllerListShiftsStatusEnum = exports.FacilityControllerGetFacilitiesSortEnum = exports.DocumentAuditControllerListLlmDecisionEnum = exports.DocumentAuditControllerListDocumentTypeEnum = exports.DocumentAuditControllerListStatusEnum = exports.DefaultApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class DefaultApi extends runtime.BaseAPI {
    /**
     * Block a user account in Auth0, preventing login
     */
    async accountControllerBlockAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling accountControllerBlockAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/block/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Block a user account in Auth0, preventing login
     */
    async accountControllerBlockAccount(requestParameters, initOverrides) {
        await this.accountControllerBlockAccountRaw(requestParameters, initOverrides);
    }
    /**
     * Delete a profile and Auth0 identities by email (disabled in production, used for e2e tests)
     */
    async accountControllerDeleteAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling accountControllerDeleteAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/deactivate/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a profile and Auth0 identities by email (disabled in production, used for e2e tests)
     */
    async accountControllerDeleteAccount(requestParameters, initOverrides) {
        await this.accountControllerDeleteAccountRaw(requestParameters, initOverrides);
    }
    /**
     * Create a facility admin profile, assign Auth0 role, and claim pending facility invitations
     */
    async accountControllerRegisterFacilityAdministratorAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerFacilityAdministratorAccountDto'] == null) {
            throw new runtime.RequiredError('registerFacilityAdministratorAccountDto', 'Required parameter "registerFacilityAdministratorAccountDto" was null or undefined when calling accountControllerRegisterFacilityAdministratorAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/facility-admin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterFacilityAdministratorAccountDtoToJSON)(requestParameters['registerFacilityAdministratorAccountDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Create a facility admin profile, assign Auth0 role, and claim pending facility invitations
     */
    async accountControllerRegisterFacilityAdministratorAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerRegisterFacilityAdministratorAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a nurse profile and assign the Auth0 nurse role during onboarding
     */
    async accountControllerRegisterNurseAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerNurseAccountDto'] == null) {
            throw new runtime.RequiredError('registerNurseAccountDto', 'Required parameter "registerNurseAccountDto" was null or undefined when calling accountControllerRegisterNurseAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/nurse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterNurseAccountDtoToJSON)(requestParameters['registerNurseAccountDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Create a nurse profile and assign the Auth0 nurse role during onboarding
     */
    async accountControllerRegisterNurseAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerRegisterNurseAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a platform admin profile with full system access (admin-only)
     */
    async accountControllerRegisterPlatformAdministratorAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerPlatformAdministratorAccountDto'] == null) {
            throw new runtime.RequiredError('registerPlatformAdministratorAccountDto', 'Required parameter "registerPlatformAdministratorAccountDto" was null or undefined when calling accountControllerRegisterPlatformAdministratorAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/platform-administrator`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterPlatformAdministratorAccountDtoToJSON)(requestParameters['registerPlatformAdministratorAccountDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Create a platform admin profile with full system access (admin-only)
     */
    async accountControllerRegisterPlatformAdministratorAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerRegisterPlatformAdministratorAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Unblock a user account in Auth0, restoring login access
     */
    async accountControllerUnblockAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling accountControllerUnblockAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/unblock/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Unblock a user account in Auth0, restoring login access
     */
    async accountControllerUnblockAccount(requestParameters, initOverrides) {
        await this.accountControllerUnblockAccountRaw(requestParameters, initOverrides);
    }
    /**
     * Create a nurse profile with duplicate check and assign Auth0 nurse role (v2 onboarding)
     */
    async accountControllerV2RegisterNurseAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['registerNurseAccountV2Dto'] == null) {
            throw new runtime.RequiredError('registerNurseAccountV2Dto', 'Required parameter "registerNurseAccountV2Dto" was null or undefined when calling accountControllerV2RegisterNurseAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/account/nurse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegisterNurseAccountV2DtoToJSON)(requestParameters['registerNurseAccountV2Dto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Create a nurse profile with duplicate check and assign Auth0 nurse role (v2 onboarding)
     */
    async accountControllerV2RegisterNurseAccount(requestParameters, initOverrides) {
        const response = await this.accountControllerV2RegisterNurseAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Calculate driving distances in miles between pairs of addresses using Google Routes API with caching
     */
    async addressDistanceControllerCalculateDistancesRaw(requestParameters, initOverrides) {
        if (requestParameters['calculateDistancesDto'] == null) {
            throw new runtime.RequiredError('calculateDistancesDto', 'Required parameter "calculateDistancesDto" was null or undefined when calling addressDistanceControllerCalculateDistances().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/address-distance/calculate-batch`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CalculateDistancesDtoToJSON)(requestParameters['calculateDistancesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.DistanceResultDtoFromJSON));
    }
    /**
     * Calculate driving distances in miles between pairs of addresses using Google Routes API with caching
     */
    async addressDistanceControllerCalculateDistances(requestParameters, initOverrides) {
        const response = await this.addressDistanceControllerCalculateDistancesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send a message to the AI assistant with MCP tool access and stream the SSE response
     */
    async adminChatControllerChatRaw(requestParameters, initOverrides) {
        if (requestParameters['adminChatRequestDto'] == null) {
            throw new runtime.RequiredError('adminChatRequestDto', 'Required parameter "adminChatRequestDto" was null or undefined when calling adminChatControllerChat().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AdminChatRequestDtoToJSON)(requestParameters['adminChatRequestDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send a message to the AI assistant with MCP tool access and stream the SSE response
     */
    async adminChatControllerChat(requestParameters, initOverrides) {
        await this.adminChatControllerChatRaw(requestParameters, initOverrides);
    }
    /**
     * Hide a conversation from the current user\'s list without deleting it
     */
    async adminChatControllerDismissConversationRaw(requestParameters, initOverrides) {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError('conversationId', 'Required parameter "conversationId" was null or undefined when calling adminChatControllerDismissConversation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-chat/conversations/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Hide a conversation from the current user\'s list without deleting it
     */
    async adminChatControllerDismissConversation(requestParameters, initOverrides) {
        await this.adminChatControllerDismissConversationRaw(requestParameters, initOverrides);
    }
    /**
     * Load a full admin chat conversation with messages and tool call history
     */
    async adminChatControllerGetConversationRaw(requestParameters, initOverrides) {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError('conversationId', 'Required parameter "conversationId" was null or undefined when calling adminChatControllerGetConversation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-chat/conversations/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ConversationResponseDtoFromJSON)(jsonValue));
    }
    /**
     * Load a full admin chat conversation with messages and tool call history
     */
    async adminChatControllerGetConversation(requestParameters, initOverrides) {
        const response = await this.adminChatControllerGetConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List recent admin chat conversations for the current user, excluding dismissed ones
     */
    async adminChatControllerListConversationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-chat/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ConversationListItemDtoFromJSON));
    }
    /**
     * List recent admin chat conversations for the current user, excluding dismissed ones
     */
    async adminChatControllerListConversations(initOverrides) {
        const response = await this.adminChatControllerListConversationsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Upload a file for use in admin chat messages
     */
    async adminChatControllerUploadFileRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        const response = await this.request({
            path: `/admin-chat/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.UploadFileResponseDtoFromJSON)(jsonValue));
    }
    /**
     * Upload a file for use in admin chat messages
     */
    async adminChatControllerUploadFile(requestParameters = {}, initOverrides) {
        const response = await this.adminChatControllerUploadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async adminControllerFastTrackProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling adminControllerFastTrackProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/{profileId}/fast-track`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async adminControllerFastTrackProfile(requestParameters, initOverrides) {
        await this.adminControllerFastTrackProfileRaw(requestParameters, initOverrides);
    }
    /**
     */
    async adminControllerGetAdminLinksRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/links`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AdminLinkDtoFromJSON));
    }
    /**
     */
    async adminControllerGetAdminLinks(initOverrides) {
        const response = await this.adminControllerGetAdminLinksRaw(initOverrides);
        return await response.value();
    }
    /**
     * Permanently dismiss a platform alert by type for the authenticated nurse
     */
    async alertControllerDismissAlertRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling alertControllerDismissAlert().');
        }
        if (requestParameters['dismissAlertDto'] == null) {
            throw new runtime.RequiredError('dismissAlertDto', 'Required parameter "dismissAlertDto" was null or undefined when calling alertControllerDismissAlert().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/alert/{profileId}/dismiss`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.DismissAlertDtoToJSON)(requestParameters['dismissAlertDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently dismiss a platform alert by type for the authenticated nurse
     */
    async alertControllerDismissAlert(requestParameters, initOverrides) {
        await this.alertControllerDismissAlertRaw(requestParameters, initOverrides);
    }
    /**
     * Record an analytics event for the authenticated user
     */
    async analyticsControllerRecordEventRaw(requestParameters, initOverrides) {
        if (requestParameters['analyticsEventDto'] == null) {
            throw new runtime.RequiredError('analyticsEventDto', 'Required parameter "analyticsEventDto" was null or undefined when calling analyticsControllerRecordEvent().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/analytics/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AnalyticsEventDtoToJSON)(requestParameters['analyticsEventDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record an analytics event for the authenticated user
     */
    async analyticsControllerRecordEvent(requestParameters, initOverrides) {
        await this.analyticsControllerRecordEventRaw(requestParameters, initOverrides);
    }
    /**
     * Record several analytics events for the authenticated user in one request
     */
    async analyticsControllerRecordEventsRaw(requestParameters, initOverrides) {
        if (requestParameters['analyticsEventBatchDto'] == null) {
            throw new runtime.RequiredError('analyticsEventBatchDto', 'Required parameter "analyticsEventBatchDto" was null or undefined when calling analyticsControllerRecordEvents().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/analytics/events/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AnalyticsEventBatchDtoToJSON)(requestParameters['analyticsEventBatchDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record several analytics events for the authenticated user in one request
     */
    async analyticsControllerRecordEvents(requestParameters, initOverrides) {
        await this.analyticsControllerRecordEventsRaw(requestParameters, initOverrides);
    }
    /**
     * Assign Relias competency assessments to a nurse (max 3 attempts per assessment)
     */
    async assessmentsControllerAssignAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerAssignAssessments().');
        }
        if (requestParameters['assignAssessmentDto'] == null) {
            throw new runtime.RequiredError('assignAssessmentDto', 'Required parameter "assignAssessmentDto" was null or undefined when calling assessmentsControllerAssignAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AssignAssessmentDtoToJSON)(requestParameters['assignAssessmentDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Assign Relias competency assessments to a nurse (max 3 attempts per assessment)
     */
    async assessmentsControllerAssignAssessments(requestParameters, initOverrides) {
        await this.assessmentsControllerAssignAssessmentsRaw(requestParameters, initOverrides);
    }
    /**
     * Assign required regulatory assessments to a nurse via Relias
     */
    async assessmentsControllerAssignRegulatoryAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerAssignRegulatoryAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/regulatory`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentsDtoFromJSON)(jsonValue));
    }
    /**
     * Assign required regulatory assessments to a nurse via Relias
     */
    async assessmentsControllerAssignRegulatoryAssessments(requestParameters, initOverrides) {
        const response = await this.assessmentsControllerAssignRegulatoryAssessmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get regulatory assessment progress with expiration and renewal dates
     */
    async assessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerGetRegulatoryAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/regulatory`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentsDtoFromJSON)(jsonValue));
    }
    /**
     * Get regulatory assessment progress with expiration and renewal dates
     */
    async assessmentsControllerGetRegulatoryAssessments(requestParameters, initOverrides) {
        const response = await this.assessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Clear previous assessment attempts and reassign them in Relias
     */
    async assessmentsControllerResetAssessmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerResetAssessments().');
        }
        if (requestParameters['resetAssessmentsDto'] == null) {
            throw new runtime.RequiredError('resetAssessmentsDto', 'Required parameter "resetAssessmentsDto" was null or undefined when calling assessmentsControllerResetAssessments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/reset`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ResetAssessmentsDtoToJSON)(requestParameters['resetAssessmentsDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Clear previous assessment attempts and reassign them in Relias
     */
    async assessmentsControllerResetAssessments(requestParameters, initOverrides) {
        await this.assessmentsControllerResetAssessmentsRaw(requestParameters, initOverrides);
    }
    /**
     * Import completed Relias assignments and update specialty/regulatory assessment statuses
     */
    async assessmentsControllerSyncReliasRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling assessmentsControllerSyncRelias().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/assessments/{profileId}/sync`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Import completed Relias assignments and update specialty/regulatory assessment statuses
     */
    async assessmentsControllerSyncRelias(requestParameters, initOverrides) {
        await this.assessmentsControllerSyncReliasRaw(requestParameters, initOverrides);
    }
    /**
     * Retrieve the change history log for an entity, including who made each change
     */
    async auditControllerGetHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError('entityType', 'Required parameter "entityType" was null or undefined when calling auditControllerGetHistory().');
        }
        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError('entityId', 'Required parameter "entityId" was null or undefined when calling auditControllerGetHistory().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/audit/history/{entityType}/{entityId}`.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType']))).replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AuditLogDtoFromJSON));
    }
    /**
     * Retrieve the change history log for an entity, including who made each change
     */
    async auditControllerGetHistory(requestParameters, initOverrides) {
        const response = await this.auditControllerGetHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel a pending Checkr invitation and delete the background check record
     */
    async backgroundCheckControllerCancelBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['cancelBackgroundCheckDto'] == null) {
            throw new runtime.RequiredError('cancelBackgroundCheckDto', 'Required parameter "cancelBackgroundCheckDto" was null or undefined when calling backgroundCheckControllerCancelBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CancelBackgroundCheckDtoToJSON)(requestParameters['cancelBackgroundCheckDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancel a pending Checkr invitation and delete the background check record
     */
    async backgroundCheckControllerCancelBackgroundCheck(requestParameters, initOverrides) {
        await this.backgroundCheckControllerCancelBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     * List all background checks for a nurse with package details and screening info
     */
    async backgroundCheckControllerGetBackgroundChecksRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling backgroundCheckControllerGetBackgroundChecks().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.BackgroundCheckDtoFromJSON));
    }
    /**
     * List all background checks for a nurse with package details and screening info
     */
    async backgroundCheckControllerGetBackgroundChecks(requestParameters, initOverrides) {
        const response = await this.backgroundCheckControllerGetBackgroundChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Record a manually verified background check for a nurse screened outside Checkr
     */
    async backgroundCheckControllerMarkBackgroundCheckClearedManuallyRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling backgroundCheckControllerMarkBackgroundCheckClearedManually().');
        }
        if (requestParameters['manualVerificationDto'] == null) {
            throw new runtime.RequiredError('manualVerificationDto', 'Required parameter "manualVerificationDto" was null or undefined when calling backgroundCheckControllerMarkBackgroundCheckClearedManually().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check/profile/{profileId}/manual-verification`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ManualVerificationDtoToJSON)(requestParameters['manualVerificationDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record a manually verified background check for a nurse screened outside Checkr
     */
    async backgroundCheckControllerMarkBackgroundCheckClearedManually(requestParameters, initOverrides) {
        await this.backgroundCheckControllerMarkBackgroundCheckClearedManuallyRaw(requestParameters, initOverrides);
    }
    /**
     * Submit a Checkr background check invitation for a nurse
     */
    async backgroundCheckControllerSubmitBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['submitBackgroundCheckDto'] == null) {
            throw new runtime.RequiredError('submitBackgroundCheckDto', 'Required parameter "submitBackgroundCheckDto" was null or undefined when calling backgroundCheckControllerSubmitBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SubmitBackgroundCheckDtoToJSON)(requestParameters['submitBackgroundCheckDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit a Checkr background check invitation for a nurse
     */
    async backgroundCheckControllerSubmitBackgroundCheck(requestParameters, initOverrides) {
        await this.backgroundCheckControllerSubmitBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     * Pull latest Checkr report results and update local authorization status
     */
    async backgroundCheckControllerSyncBackgroundCheckStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling backgroundCheckControllerSyncBackgroundCheckStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.BackgroundCheckStatusDtoFromJSON));
    }
    /**
     * Pull latest Checkr report results and update local authorization status
     */
    async backgroundCheckControllerSyncBackgroundCheckStatus(requestParameters, initOverrides) {
        const response = await this.backgroundCheckControllerSyncBackgroundCheckStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List active background check packages synced from every provider
     */
    async backgroundCheckPackageControllerGetPackagesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check-packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.BackgroundCheckPackageDtoFromJSON));
    }
    /**
     * List active background check packages synced from every provider
     */
    async backgroundCheckPackageControllerGetPackages(initOverrides) {
        const response = await this.backgroundCheckPackageControllerGetPackagesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Pull the latest packages and screenings from every background check provider
     */
    async backgroundCheckPackageControllerSyncPackagesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/background-check-packages/sync`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Pull the latest packages and screenings from every background check provider
     */
    async backgroundCheckPackageControllerSyncPackages(initOverrides) {
        await this.backgroundCheckPackageControllerSyncPackagesRaw(initOverrides);
    }
    /**
     * Get platform and employer tax fee percentages, optionally for a specific facility
     */
    async billingControllerGetFeesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/fees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BillingFeesDtoFromJSON)(jsonValue));
    }
    /**
     * Get platform and employer tax fee percentages, optionally for a specific facility
     */
    async billingControllerGetFees(requestParameters = {}, initOverrides) {
        const response = await this.billingControllerGetFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List facility IDs with uninvoiced completed shifts that have a billing contact and Stripe customer
     */
    async billingInvoiceControllerGetInvoiceableFaciltiesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/facilities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List facility IDs with uninvoiced completed shifts that have a billing contact and Stripe customer
     */
    async billingInvoiceControllerGetInvoiceableFacilties(initOverrides) {
        const response = await this.billingInvoiceControllerGetInvoiceableFaciltiesRaw(initOverrides);
        return await response.value();
    }
    /**
     * List Stripe invoices with shift details, optionally filtered by pay period date range
     */
    async billingInvoiceControllerGetInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters['payPeriodStart'] == null) {
            throw new runtime.RequiredError('payPeriodStart', 'Required parameter "payPeriodStart" was null or undefined when calling billingInvoiceControllerGetInvoices().');
        }
        if (requestParameters['payPeriodEnd'] == null) {
            throw new runtime.RequiredError('payPeriodEnd', 'Required parameter "payPeriodEnd" was null or undefined when calling billingInvoiceControllerGetInvoices().');
        }
        const queryParameters = {};
        if (requestParameters['payPeriodStart'] != null) {
            queryParameters['payPeriodStart'] = requestParameters['payPeriodStart'];
        }
        if (requestParameters['payPeriodEnd'] != null) {
            queryParameters['payPeriodEnd'] = requestParameters['payPeriodEnd'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InvoiceDtoFromJSON));
    }
    /**
     * List Stripe invoices with shift details, optionally filtered by pay period date range
     */
    async billingInvoiceControllerGetInvoices(requestParameters, initOverrides) {
        const response = await this.billingInvoiceControllerGetInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Reconcile the latest billing week\'s invoices against Stripe and flag stale drafts and unpaid invoices
     */
    async billingInvoiceControllerGetWeeklyDigestRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/weekly-digest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InvoicingDigestDtoFromJSON)(jsonValue));
    }
    /**
     * Reconcile the latest billing week\'s invoices against Stripe and flag stale drafts and unpaid invoices
     */
    async billingInvoiceControllerGetWeeklyDigest(initOverrides) {
        const response = await this.billingInvoiceControllerGetWeeklyDigestRaw(initOverrides);
        return await response.value();
    }
    /**
     * Preview the uninvoiced completed shifts a true up would bill, grouped by facility
     */
    async billingInvoiceControllerPreviewTrueUpRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['payPeriodEnd'] != null) {
            queryParameters['payPeriodEnd'] = requestParameters['payPeriodEnd'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/true-up/preview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InvoiceDtoFromJSON));
    }
    /**
     * Preview the uninvoiced completed shifts a true up would bill, grouped by facility
     */
    async billingInvoiceControllerPreviewTrueUp(requestParameters = {}, initOverrides) {
        const response = await this.billingInvoiceControllerPreviewTrueUpRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Generate Stripe draft invoices for every facility with uninvoiced completed shifts through a pay period
     */
    async billingInvoiceControllerTrueUpInvoicesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['payPeriodEnd'] != null) {
            queryParameters['payPeriodEnd'] = requestParameters['payPeriodEnd'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing-invoice/true-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.TrueUpResultDtoFromJSON));
    }
    /**
     * Generate Stripe draft invoices for every facility with uninvoiced completed shifts through a pay period
     */
    async billingInvoiceControllerTrueUpInvoices(requestParameters = {}, initOverrides) {
        const response = await this.billingInvoiceControllerTrueUpInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Pay a nurse an extra amount for working a shift, with a description explaining why
     */
    async bonusControllerAddBonusRaw(requestParameters, initOverrides) {
        if (requestParameters['bonusCreateDto'] == null) {
            throw new runtime.RequiredError('bonusCreateDto', 'Required parameter "bonusCreateDto" was null or undefined when calling bonusControllerAddBonus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.BonusCreateDtoToJSON)(requestParameters['bonusCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     * Pay a nurse an extra amount for working a shift, with a description explaining why
     */
    async bonusControllerAddBonus(requestParameters, initOverrides) {
        const response = await this.bonusControllerAddBonusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Take a bonus away so the nurse is no longer paid it
     */
    async bonusControllerDeleteBonusRaw(requestParameters, initOverrides) {
        if (requestParameters['bonusId'] == null) {
            throw new runtime.RequiredError('bonusId', 'Required parameter "bonusId" was null or undefined when calling bonusControllerDeleteBonus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/{bonusId}`.replace(`{${"bonusId"}}`, encodeURIComponent(String(requestParameters['bonusId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Take a bonus away so the nurse is no longer paid it
     */
    async bonusControllerDeleteBonus(requestParameters, initOverrides) {
        await this.bonusControllerDeleteBonusRaw(requestParameters, initOverrides);
    }
    /**
     * Change how much a bonus pays and the reason given for it
     */
    async bonusControllerUpdateBonusRaw(requestParameters, initOverrides) {
        if (requestParameters['bonusId'] == null) {
            throw new runtime.RequiredError('bonusId', 'Required parameter "bonusId" was null or undefined when calling bonusControllerUpdateBonus().');
        }
        if (requestParameters['bonusUpdateDto'] == null) {
            throw new runtime.RequiredError('bonusUpdateDto', 'Required parameter "bonusUpdateDto" was null or undefined when calling bonusControllerUpdateBonus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/{bonusId}`.replace(`{${"bonusId"}}`, encodeURIComponent(String(requestParameters['bonusId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.BonusUpdateDtoToJSON)(requestParameters['bonusUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BonusDtoFromJSON)(jsonValue));
    }
    /**
     * Change how much a bonus pays and the reason given for it
     */
    async bonusControllerUpdateBonus(requestParameters, initOverrides) {
        const response = await this.bonusControllerUpdateBonusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove a certification record from a nurse profile
     */
    async certificationControllerDeleteCertificationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerDeleteCertification().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerDeleteCertification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a certification record from a nurse profile
     */
    async certificationControllerDeleteCertification(requestParameters, initOverrides) {
        await this.certificationControllerDeleteCertificationRaw(requestParameters, initOverrides);
    }
    /**
     * Get a single certification (e.g. BLS, ACLS) with card document and specialty requirement info
     */
    async certificationControllerGetCertificationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerGetCertification().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerGetCertification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CertificationDtoFromJSON)(jsonValue));
    }
    /**
     * Get a single certification (e.g. BLS, ACLS) with card document and specialty requirement info
     */
    async certificationControllerGetCertification(requestParameters, initOverrides) {
        const response = await this.certificationControllerGetCertificationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get BLS, ACLS, PALS, and other certifications for a nurse including specialty requirements
     */
    async certificationControllerGetCertificationsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerGetCertifications().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.CertificationDtoFromJSON));
    }
    /**
     * Get BLS, ACLS, PALS, and other certifications for a nurse including specialty requirements
     */
    async certificationControllerGetCertifications(requestParameters, initOverrides) {
        const response = await this.certificationControllerGetCertificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Approve or reject a certification and sync specialty eligibility status
     */
    async certificationControllerSetVerificationStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerSetVerificationStatus().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerSetVerificationStatus().');
        }
        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError('status', 'Required parameter "status" was null or undefined when calling certificationControllerSetVerificationStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}/status/{status}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))).replace(`{${"status"}}`, encodeURIComponent(String(requestParameters['status']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Approve or reject a certification and sync specialty eligibility status
     */
    async certificationControllerSetVerificationStatus(requestParameters, initOverrides) {
        await this.certificationControllerSetVerificationStatusRaw(requestParameters, initOverrides);
    }
    /**
     * Submit a certification with AHA eCard or RQI code for auto-verification against external providers
     */
    async certificationControllerUpdateCertificationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerUpdateCertification().');
        }
        if (requestParameters['certificationDto'] == null) {
            throw new runtime.RequiredError('certificationDto', 'Required parameter "certificationDto" was null or undefined when calling certificationControllerUpdateCertification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/certification/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CertificationDtoToJSON)(requestParameters['certificationDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit a certification with AHA eCard or RQI code for auto-verification against external providers
     */
    async certificationControllerUpdateCertification(requestParameters, initOverrides) {
        await this.certificationControllerUpdateCertificationRaw(requestParameters, initOverrides);
    }
    /**
     * Upload a photo or PDF of a certification card (e.g. BLS, ACLS) as proof
     */
    async certificationControllerUploadCertificationCardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling certificationControllerUploadCertificationCard().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling certificationControllerUploadCertificationCard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['certificationCard'] != null) {
            formParams.append('certificationCard', requestParameters['certificationCard']);
        }
        const response = await this.request({
            path: `/certification/{profileId}/{code}/certification-card`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload a photo or PDF of a certification card (e.g. BLS, ACLS) as proof
     */
    async certificationControllerUploadCertificationCard(requestParameters, initOverrides) {
        await this.certificationControllerUploadCertificationCardRaw(requestParameters, initOverrides);
    }
    /**
     * Process Courier email engagement events
     */
    async courierWebhookControllerHandleCourierWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['courierWebhookEventDto'] == null) {
            throw new runtime.RequiredError('courierWebhookEventDto', 'Required parameter "courierWebhookEventDto" was null or undefined when calling courierWebhookControllerHandleCourierWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/user-notification/webhook/courier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CourierWebhookEventDtoToJSON)(requestParameters['courierWebhookEventDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Courier email engagement events
     */
    async courierWebhookControllerHandleCourierWebhook(requestParameters, initOverrides) {
        await this.courierWebhookControllerHandleCourierWebhookRaw(requestParameters, initOverrides);
    }
    /**
     * List nurse profile IDs with expired or expiring licenses, certifications, vaccinations, TB screenings, or regulatory assessments
     */
    async credentialsCheckControllerGetProfilesWithExpiredCredentialsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['expiredAfter'] != null) {
            queryParameters['expiredAfter'] = requestParameters['expiredAfter'].toISOString();
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credentials-check/profiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List nurse profile IDs with expired or expiring licenses, certifications, vaccinations, TB screenings, or regulatory assessments
     */
    async credentialsCheckControllerGetProfilesWithExpiredCredentials(requestParameters = {}, initOverrides) {
        const response = await this.credentialsCheckControllerGetProfilesWithExpiredCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send expiration notifications for a nurse\'s expired licenses, certifications, vaccinations, TB screenings, and regulatory assessments
     */
    async credentialsCheckControllerNotifyNurseOfExpiredCredentialsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling credentialsCheckControllerNotifyNurseOfExpiredCredentials().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credentials-check/profiles/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send expiration notifications for a nurse\'s expired licenses, certifications, vaccinations, TB screenings, and regulatory assessments
     */
    async credentialsCheckControllerNotifyNurseOfExpiredCredentials(requestParameters, initOverrides) {
        await this.credentialsCheckControllerNotifyNurseOfExpiredCredentialsRaw(requestParameters, initOverrides);
    }
    /**
     * Check assigned nurses on upcoming shifts for expired credentials and auto-remove unqualified assignments
     */
    async credentialsCheckControllerValidateUpcomingShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['validateUpcomingShiftsDto'] == null) {
            throw new runtime.RequiredError('validateUpcomingShiftsDto', 'Required parameter "validateUpcomingShiftsDto" was null or undefined when calling credentialsCheckControllerValidateUpcomingShifts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/credentials-check/validate-upcoming-shifts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ValidateUpcomingShiftsDtoToJSON)(requestParameters['validateUpcomingShiftsDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ValidateUpcomingShiftsResultDtoFromJSON)(jsonValue));
    }
    /**
     * Check assigned nurses on upcoming shifts for expired credentials and auto-remove unqualified assignments
     */
    async credentialsCheckControllerValidateUpcomingShifts(requestParameters, initOverrides) {
        const response = await this.credentialsCheckControllerValidateUpcomingShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get DHS background check status and fingerprint date for a nurse
     */
    async dhsBackgroundCheckControllerGetDhsBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerGetDhsBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.DhsBackgroundCheckStatusDtoFromJSON)(jsonValue));
    }
    /**
     * Get DHS background check status and fingerprint date for a nurse
     */
    async dhsBackgroundCheckControllerGetDhsBackgroundCheck(requestParameters, initOverrides) {
        const response = await this.dhsBackgroundCheckControllerGetDhsBackgroundCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve a DHS clearance letter or registry check result document
     */
    async dhsBackgroundCheckControllerGetDhsDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerGetDhsDocument().');
        }
        if (requestParameters['documentType'] == null) {
            throw new runtime.RequiredError('documentType', 'Required parameter "documentType" was null or undefined when calling dhsBackgroundCheckControllerGetDhsDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/{documentType}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters['documentType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.StoredDocumentDtoFromJSON)(jsonValue));
    }
    /**
     * Retrieve a DHS clearance letter or registry check result document
     */
    async dhsBackgroundCheckControllerGetDhsDocument(requestParameters, initOverrides) {
        const response = await this.dhsBackgroundCheckControllerGetDhsDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a DHS clearance letter or registry check result document
     */
    async dhsBackgroundCheckControllerRemoveDhsDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerRemoveDhsDocument().');
        }
        if (requestParameters['documentType'] == null) {
            throw new runtime.RequiredError('documentType', 'Required parameter "documentType" was null or undefined when calling dhsBackgroundCheckControllerRemoveDhsDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/{documentType}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters['documentType']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a DHS clearance letter or registry check result document
     */
    async dhsBackgroundCheckControllerRemoveDhsDocument(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerRemoveDhsDocumentRaw(requestParameters, initOverrides);
    }
    /**
     * Initiate a DHS background check and send fingerprinting instructions email
     */
    async dhsBackgroundCheckControllerRequestBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerRequestBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Initiate a DHS background check and send fingerprinting instructions email
     */
    async dhsBackgroundCheckControllerRequestBackgroundCheck(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerRequestBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     * Resend DHS fingerprinting instructions email for a pending check
     */
    async dhsBackgroundCheckControllerResendBackgroundCheckEmailRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerResendBackgroundCheckEmail().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/resend-email`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Resend DHS fingerprinting instructions email for a pending check
     */
    async dhsBackgroundCheckControllerResendBackgroundCheckEmail(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerResendBackgroundCheckEmailRaw(requestParameters, initOverrides);
    }
    /**
     * Approve or update DHS background check status and fingerprint date
     */
    async dhsBackgroundCheckControllerUpdateDhsBackgroundCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerUpdateDhsBackgroundCheck().');
        }
        if (requestParameters['dhsBackgroundCheckStatusDto'] == null) {
            throw new runtime.RequiredError('dhsBackgroundCheckStatusDto', 'Required parameter "dhsBackgroundCheckStatusDto" was null or undefined when calling dhsBackgroundCheckControllerUpdateDhsBackgroundCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.DhsBackgroundCheckStatusDtoToJSON)(requestParameters['dhsBackgroundCheckStatusDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Approve or update DHS background check status and fingerprint date
     */
    async dhsBackgroundCheckControllerUpdateDhsBackgroundCheck(requestParameters, initOverrides) {
        await this.dhsBackgroundCheckControllerUpdateDhsBackgroundCheckRaw(requestParameters, initOverrides);
    }
    /**
     * Upload a DHS clearance letter or registry check result (PNG, JPEG, PDF)
     */
    async dhsBackgroundCheckControllerUploadDhsDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling dhsBackgroundCheckControllerUploadDhsDocument().');
        }
        if (requestParameters['documentType'] == null) {
            throw new runtime.RequiredError('documentType', 'Required parameter "documentType" was null or undefined when calling dhsBackgroundCheckControllerUploadDhsDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['letter'] != null) {
            formParams.append('letter', requestParameters['letter']);
        }
        const response = await this.request({
            path: `/dhs-background-check/{profileId}/{documentType}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters['documentType']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.StoredDocumentDtoFromJSON)(jsonValue));
    }
    /**
     * Upload a DHS clearance letter or registry check result (PNG, JPEG, PDF)
     */
    async dhsBackgroundCheckControllerUploadDhsDocument(requestParameters, initOverrides) {
        const response = await this.dhsBackgroundCheckControllerUploadDhsDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a single auditable stored document with download URL and current decisions
     */
    async documentAuditControllerGetDetailRaw(requestParameters, initOverrides) {
        if (requestParameters['storedDocumentId'] == null) {
            throw new runtime.RequiredError('storedDocumentId', 'Required parameter "storedDocumentId" was null or undefined when calling documentAuditControllerGetDetail().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document-audit/{storedDocumentId}`.replace(`{${"storedDocumentId"}}`, encodeURIComponent(String(requestParameters['storedDocumentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.DocumentAuditDetailDtoFromJSON)(jsonValue));
    }
    /**
     * Get a single auditable stored document with download URL and current decisions
     */
    async documentAuditControllerGetDetail(requestParameters, initOverrides) {
        const response = await this.documentAuditControllerGetDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List nurse-uploaded credential documents available for credentialing review. The `search` param matches the owning nurse\'s name, email, or internal admin notes, and the reviewer\'s internal notes on the document itself.
     */
    async documentAuditControllerListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['documentType'] != null) {
            queryParameters['documentType'] = requestParameters['documentType'];
        }
        if (requestParameters['llmDecision'] != null) {
            queryParameters['llmDecision'] = requestParameters['llmDecision'];
        }
        if (requestParameters['expired'] != null) {
            queryParameters['expired'] = requestParameters['expired'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document-audit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfDocumentAuditListItemDtoFromJSON)(jsonValue));
    }
    /**
     * List nurse-uploaded credential documents available for credentialing review. The `search` param matches the owning nurse\'s name, email, or internal admin notes, and the reviewer\'s internal notes on the document itself.
     */
    async documentAuditControllerList(requestParameters = {}, initOverrides) {
        const response = await this.documentAuditControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Record a human approve/reject decision on a stored document
     */
    async documentAuditControllerRecordDecisionRaw(requestParameters, initOverrides) {
        if (requestParameters['storedDocumentId'] == null) {
            throw new runtime.RequiredError('storedDocumentId', 'Required parameter "storedDocumentId" was null or undefined when calling documentAuditControllerRecordDecision().');
        }
        if (requestParameters['documentAuditDecisionRequestDto'] == null) {
            throw new runtime.RequiredError('documentAuditDecisionRequestDto', 'Required parameter "documentAuditDecisionRequestDto" was null or undefined when calling documentAuditControllerRecordDecision().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document-audit/{storedDocumentId}/decision`.replace(`{${"storedDocumentId"}}`, encodeURIComponent(String(requestParameters['storedDocumentId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.DocumentAuditDecisionRequestDtoToJSON)(requestParameters['documentAuditDecisionRequestDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record a human approve/reject decision on a stored document
     */
    async documentAuditControllerRecordDecision(requestParameters, initOverrides) {
        await this.documentAuditControllerRecordDecisionRaw(requestParameters, initOverrides);
    }
    /**
     * Run (or re-run) the LLM pre-screen for a stored document; replaces any prior LLM verdict
     */
    async documentAuditControllerRunPreScreenRaw(requestParameters, initOverrides) {
        if (requestParameters['storedDocumentId'] == null) {
            throw new runtime.RequiredError('storedDocumentId', 'Required parameter "storedDocumentId" was null or undefined when calling documentAuditControllerRunPreScreen().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document-audit/{storedDocumentId}/llm-pre-screen`.replace(`{${"storedDocumentId"}}`, encodeURIComponent(String(requestParameters['storedDocumentId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.DocumentAuditDetailDtoFromJSON)(jsonValue));
    }
    /**
     * Run (or re-run) the LLM pre-screen for a stored document; replaces any prior LLM verdict
     */
    async documentAuditControllerRunPreScreen(requestParameters, initOverrides) {
        const response = await this.documentAuditControllerRunPreScreenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Process Zeal webhook when a nurse payroll check is created or updated
     */
    async employeeCheckEventControllerHandleEmployeeCheckEventRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/employee-check-event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Zeal webhook when a nurse payroll check is created or updated
     */
    async employeeCheckEventControllerHandleEmployeeCheckEvent(initOverrides) {
        await this.employeeCheckEventControllerHandleEmployeeCheckEventRaw(initOverrides);
    }
    /**
     * Process Zeal webhook when an employer payroll check is processed and disbursement status changes
     */
    async employeeCheckEventControllerHandleEmployerCheckProcessedLiteEventRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/employer-check-processed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Zeal webhook when an employer payroll check is processed and disbursement status changes
     */
    async employeeCheckEventControllerHandleEmployerCheckProcessedLiteEvent(initOverrides) {
        await this.employeeCheckEventControllerHandleEmployerCheckProcessedLiteEventRaw(initOverrides);
    }
    /**
     * Process Zeal webhook when a nurse\'s I-9 employment verification status changes
     */
    async employeeI9EventControllerHandleEmployeeI9EventRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/employee-i9-event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Zeal webhook when a nurse\'s I-9 employment verification status changes
     */
    async employeeI9EventControllerHandleEmployeeI9Event(initOverrides) {
        await this.employeeI9EventControllerHandleEmployeeI9EventRaw(initOverrides);
    }
    /**
     * Block a nurse from a facility, declining their pending requests and removing facility interest
     */
    async facilityControllerBlockNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerBlockNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerBlockNurse().');
        }
        const queryParameters = {};
        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/block`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Block a nurse from a facility, declining their pending requests and removing facility interest
     */
    async facilityControllerBlockNurse(requestParameters, initOverrides) {
        await this.facilityControllerBlockNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Revoke a pending admin invitation by removing it from the user Auth0 metadata
     */
    async facilityControllerCancelInviteRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerCancelInvite().');
        }
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling facilityControllerCancelInvite().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invite/{email}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Revoke a pending admin invitation by removing it from the user Auth0 metadata
     */
    async facilityControllerCancelInvite(requestParameters, initOverrides) {
        await this.facilityControllerCancelInviteRaw(requestParameters, initOverrides);
    }
    /**
     * Register a new facility with address, contacts, and geocoded location
     */
    async facilityControllerCreateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityCreateDto'] == null) {
            throw new runtime.RequiredError('facilityCreateDto', 'Required parameter "facilityCreateDto" was null or undefined when calling facilityControllerCreateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityCreateDtoToJSON)(requestParameters['facilityCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityDtoFromJSON)(jsonValue));
    }
    /**
     * Register a new facility with address, contacts, and geocoded location
     */
    async facilityControllerCreateFacility(requestParameters, initOverrides) {
        const response = await this.facilityControllerCreateFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Mark a facility as inactive so it no longer appears in listings
     */
    async facilityControllerDeactivateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDeactivateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Mark a facility as inactive so it no longer appears in listings
     */
    async facilityControllerDeactivateFacility(requestParameters, initOverrides) {
        await this.facilityControllerDeactivateFacilityRaw(requestParameters, initOverrides);
    }
    /**
     * Remove an admin member from a facility, revoking their management access
     */
    async facilityControllerDeleteFacilityMemberRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDeleteFacilityMember().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerDeleteFacilityMember().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/{profileId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove an admin member from a facility, revoking their management access
     */
    async facilityControllerDeleteFacilityMember(requestParameters, initOverrides) {
        await this.facilityControllerDeleteFacilityMemberRaw(requestParameters, initOverrides);
    }
    /**
     * Revoke a nurse verification so they can no longer be assigned to shifts at this facility
     */
    async facilityControllerDeleteNurseVerificationRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDeleteNurseVerification().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerDeleteNurseVerification().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/verify`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Revoke a nurse verification so they can no longer be assigned to shifts at this facility
     */
    async facilityControllerDeleteNurseVerification(requestParameters, initOverrides) {
        await this.facilityControllerDeleteNurseVerificationRaw(requestParameters, initOverrides);
    }
    /**
     * Dismiss an interested nurse to the facility\'s archived list without notifying them
     */
    async facilityControllerDismissInterestedNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerDismissInterestedNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerDismissInterestedNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/interested-nurse/{profileId}/dismiss`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Dismiss an interested nurse to the facility\'s archived list without notifying them
     */
    async facilityControllerDismissInterestedNurse(requestParameters, initOverrides) {
        await this.facilityControllerDismissInterestedNurseRaw(requestParameters, initOverrides);
    }
    /**
     * List facilities the current user is a member of, or all facilities for admins, with optional search and sorting
     */
    async facilityControllerGetFacilitiesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityDtoFromJSON));
    }
    /**
     * List facilities the current user is a member of, or all facilities for admins, with optional search and sorting
     */
    async facilityControllerGetFacilities(requestParameters = {}, initOverrides) {
        const response = await this.facilityControllerGetFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get facility details including address, photo, and nurse interest status
     */
    async facilityControllerGetFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetFacility().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityDtoFromJSON)(jsonValue));
    }
    /**
     * Get facility details including address, photo, and nurse interest status
     */
    async facilityControllerGetFacility(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get billing contact details, accounts payable email, and Stripe customer portal link
     */
    async facilityControllerGetFacilityBillingContactRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetFacilityBillingContact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/billing`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BillingContactPortalDtoFromJSON)(jsonValue));
    }
    /**
     * Get billing contact details, accounts payable email, and Stripe customer portal link
     */
    async facilityControllerGetFacilityBillingContact(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetFacilityBillingContactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List invoices for a facility including pending, draft, and finalized invoices
     */
    async facilityControllerGetFacilityInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetFacilityInvoices().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invoices`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InvoiceDtoFromJSON));
    }
    /**
     * List invoices for a facility including pending, draft, and finalized invoices
     */
    async facilityControllerGetFacilityInvoices(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetFacilityInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List outstanding admin invitations that have not yet been accepted
     */
    async facilityControllerGetPendingInvitesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetPendingInvites().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invite`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InviteDtoFromJSON));
    }
    /**
     * List outstanding admin invitations that have not yet been accepted
     */
    async facilityControllerGetPendingInvites(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetPendingInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the rate and stipends this facility last used, for pre-filling the posting form. Shift type is never a filter, so an orientation shift\'s rate can be suggested for a clinical one.
     */
    async facilityControllerGetSuggestedShiftRateRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerGetSuggestedShiftRate().');
        }
        const queryParameters = {};
        if (requestParameters['specialtyCode'] != null) {
            queryParameters['specialtyCode'] = requestParameters['specialtyCode'];
        }
        if (requestParameters['nurseProfileId'] != null) {
            queryParameters['nurseProfileId'] = requestParameters['nurseProfileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift/suggested-rate`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.SuggestedShiftRateDtoFromJSON)(jsonValue));
    }
    /**
     * Get the rate and stipends this facility last used, for pre-filling the posting form. Shift type is never a filter, so an orientation shift\'s rate can be suggested for a clinical one.
     */
    async facilityControllerGetSuggestedShiftRate(requestParameters, initOverrides) {
        const response = await this.facilityControllerGetSuggestedShiftRateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Invite a nurse to join Humla, emailing them a personalized sign-up link from the facility leader
     */
    async facilityControllerInviteNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerInviteNurse().');
        }
        if (requestParameters['nurseInviteCreateDto'] == null) {
            throw new runtime.RequiredError('nurseInviteCreateDto', 'Required parameter "nurseInviteCreateDto" was null or undefined when calling facilityControllerInviteNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invite-nurse`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseInviteCreateDtoToJSON)(requestParameters['nurseInviteCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Invite a nurse to join Humla, emailing them a personalized sign-up link from the facility leader
     */
    async facilityControllerInviteNurse(requestParameters, initOverrides) {
        await this.facilityControllerInviteNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Send email invitations to one or more users to join a facility as administrators
     */
    async facilityControllerInviteUserRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerInviteUser().');
        }
        if (requestParameters['inviteCreateDto'] == null) {
            throw new runtime.RequiredError('inviteCreateDto', 'Required parameter "inviteCreateDto" was null or undefined when calling facilityControllerInviteUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/invite`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.InviteCreateDtoToJSON)(requestParameters['inviteCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send email invitations to one or more users to join a facility as administrators
     */
    async facilityControllerInviteUser(requestParameters, initOverrides) {
        await this.facilityControllerInviteUserRaw(requestParameters, initOverrides);
    }
    /**
     * List nurses who expressed interest in working at a facility, with profile completeness and specialty preferences
     */
    async facilityControllerListInterestedNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListInterestedNurses().');
        }
        const queryParameters = {};
        if (requestParameters['excludeVerified'] != null) {
            queryParameters['excludeVerified'] = requestParameters['excludeVerified'];
        }
        if (requestParameters['includeArchived'] != null) {
            queryParameters['includeArchived'] = requestParameters['includeArchived'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/interested-nurses`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityInterestedNurseDtoFromJSON));
    }
    /**
     * List nurses who expressed interest in working at a facility, with profile completeness and specialty preferences
     */
    async facilityControllerListInterestedNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListInterestedNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List profiles who are admin members of a facility
     */
    async facilityControllerListMembersRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListMembers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/members`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityMemberDtoFromJSON));
    }
    /**
     * List profiles who are admin members of a facility
     */
    async facilityControllerListMembers(requestParameters, initOverrides) {
        const response = await this.facilityControllerListMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get counts of nurses by tab (my nurses, blocked, interested) for tab badges
     */
    async facilityControllerListNurseCountsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListNurseCounts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/counts`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityNurseListCountsDtoFromJSON)(jsonValue));
    }
    /**
     * Get counts of nurses by tab (my nurses, blocked, interested) for tab badges
     */
    async facilityControllerListNurseCounts(requestParameters, initOverrides) {
        const response = await this.facilityControllerListNurseCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List nurses verified, oriented, or blocked at a facility with their specialties and block status
     */
    async facilityControllerListNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListNurses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityNurseDtoFromJSON));
    }
    /**
     * List nurses verified, oriented, or blocked at a facility with their specialties and block status
     */
    async facilityControllerListNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get counts of clinical and on-call shifts by status (open, upcoming, complete, canceled) for tab badges
     */
    async facilityControllerListShiftCountsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListShiftCounts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift/counts`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityShiftListCountsDtoFromJSON)(jsonValue));
    }
    /**
     * Get counts of clinical and on-call shifts by status (open, upcoming, complete, canceled) for tab badges
     */
    async facilityControllerListShiftCounts(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List verified nurses qualified and available to work a shift who have not yet been requested
     */
    async facilityControllerListShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerListShiftMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}/matches`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftMatchDtoFromJSON));
    }
    /**
     * List verified nurses qualified and available to work a shift who have not yet been requested
     */
    async facilityControllerListShiftMatches(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List nurses who have been requested or who applied for a shift, with who initiated each request
     */
    async facilityControllerListShiftRequestsFromNursesRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerListShiftRequestsFromNurses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}/requests`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRequestDtoFromJSON));
    }
    /**
     * List nurses who have been requested or who applied for a shift, with who initiated each request
     */
    async facilityControllerListShiftRequestsFromNurses(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftRequestsFromNursesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List, per nurse profile, every time the nurse viewed the shift (most recent first)
     */
    async facilityControllerListShiftViewsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerListShiftViews().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}/views`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftViewsByProfileDtoFromJSON));
    }
    /**
     * List, per nurse profile, every time the nurse viewed the shift (most recent first)
     */
    async facilityControllerListShiftViews(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftViewsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List shifts by status tab with filtering by type, time, date range, specialty, cost, and assigned nurse
     */
    async facilityControllerListShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerListShifts().');
        }
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = requestParameters['startDateFrom'];
        }
        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = requestParameters['startDateTo'];
        }
        if (requestParameters['createdAtFrom'] != null) {
            queryParameters['createdAtFrom'] = requestParameters['createdAtFrom'];
        }
        if (requestParameters['createdAtTo'] != null) {
            queryParameters['createdAtTo'] = requestParameters['createdAtTo'];
        }
        if (requestParameters['minCost'] != null) {
            queryParameters['minCost'] = requestParameters['minCost'];
        }
        if (requestParameters['maxCost'] != null) {
            queryParameters['maxCost'] = requestParameters['maxCost'];
        }
        if (requestParameters['claimedByProfileIds'] != null) {
            queryParameters['claimedByProfileIds'] = requestParameters['claimedByProfileIds'];
        }
        if (requestParameters['postedByProfileIds'] != null) {
            queryParameters['postedByProfileIds'] = requestParameters['postedByProfileIds'];
        }
        if (requestParameters['specialtyCodes'] != null) {
            queryParameters['specialtyCodes'] = requestParameters['specialtyCodes'];
        }
        if (requestParameters['shiftTimes'] != null) {
            queryParameters['shiftTimes'] = requestParameters['shiftTimes'];
        }
        if (requestParameters['shiftType'] != null) {
            queryParameters['shiftType'] = requestParameters['shiftType'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfFacilityShiftListItemDtoFromJSON)(jsonValue));
    }
    /**
     * List shifts by status tab with filtering by type, time, date range, specialty, cost, and assigned nurse
     */
    async facilityControllerListShifts(requestParameters, initOverrides) {
        const response = await this.facilityControllerListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Preview nurses eligible for orientation at a facility, filtered by specialty and travel distance
     */
    async facilityControllerPreviewOrientationMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerPreviewOrientationMatches().');
        }
        const queryParameters = {};
        if (requestParameters['specialtyCode'] != null) {
            queryParameters['specialtyCode'] = requestParameters['specialtyCode'];
        }
        if (requestParameters['stipendMinimumDistance'] != null) {
            queryParameters['stipendMinimumDistance'] = requestParameters['stipendMinimumDistance'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/orientation-matches-preview`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationMatchPreviewDtoFromJSON));
    }
    /**
     * Preview nurses eligible for orientation at a facility, filtered by specialty and travel distance
     */
    async facilityControllerPreviewOrientationMatches(requestParameters, initOverrides) {
        const response = await this.facilityControllerPreviewOrientationMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Restore a previously deactivated facility to active status
     */
    async facilityControllerReactivateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerReactivateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/reactivate`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Restore a previously deactivated facility to active status
     */
    async facilityControllerReactivateFacility(requestParameters, initOverrides) {
        await this.facilityControllerReactivateFacilityRaw(requestParameters, initOverrides);
    }
    /**
     * Restore an archived interested nurse to the facility\'s active list without notifying them
     */
    async facilityControllerRestoreInterestedNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerRestoreInterestedNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerRestoreInterestedNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/interested-nurse/{profileId}/restore`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Restore an archived interested nurse to the facility\'s active list without notifying them
     */
    async facilityControllerRestoreInterestedNurse(requestParameters, initOverrides) {
        await this.facilityControllerRestoreInterestedNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Get shifts for a given month with nurse requests and proposals, for calendar view
     */
    async facilityControllerShiftCalendarRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerShiftCalendar().');
        }
        const queryParameters = {};
        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/shift/calendar`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfFacilityShiftListItemDtoFromJSON)(jsonValue));
    }
    /**
     * Get shifts for a given month with nurse requests and proposals, for calendar view
     */
    async facilityControllerShiftCalendar(requestParameters, initOverrides) {
        const response = await this.facilityControllerShiftCalendarRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove a block on a nurse, allowing them to be matched and requested for shifts again
     */
    async facilityControllerUnblockNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUnblockNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerUnblockNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/block`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a block on a nurse, allowing them to be matched and requested for shifts again
     */
    async facilityControllerUnblockNurse(requestParameters, initOverrides) {
        await this.facilityControllerUnblockNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Update facility name, settings, or address with geocoding
     */
    async facilityControllerUpdateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUpdateFacility().');
        }
        if (requestParameters['facilityUpdateDto'] == null) {
            throw new runtime.RequiredError('facilityUpdateDto', 'Required parameter "facilityUpdateDto" was null or undefined when calling facilityControllerUpdateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityUpdateDtoToJSON)(requestParameters['facilityUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityDtoFromJSON)(jsonValue));
    }
    /**
     * Update facility name, settings, or address with geocoding
     */
    async facilityControllerUpdateFacility(requestParameters, initOverrides) {
        const response = await this.facilityControllerUpdateFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update billing contact, address, and accounts payable email for Stripe invoicing
     */
    async facilityControllerUpdateFacilityBillingContactRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUpdateFacilityBillingContact().');
        }
        if (requestParameters['billingContactUpdateDto'] == null) {
            throw new runtime.RequiredError('billingContactUpdateDto', 'Required parameter "billingContactUpdateDto" was null or undefined when calling facilityControllerUpdateFacilityBillingContact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/billing`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.BillingContactUpdateDtoToJSON)(requestParameters['billingContactUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityContactDtoFromJSON)(jsonValue));
    }
    /**
     * Create or update billing contact, address, and accounts payable email for Stripe invoicing
     */
    async facilityControllerUpdateFacilityBillingContact(requestParameters, initOverrides) {
        const response = await this.facilityControllerUpdateFacilityBillingContactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Set the platform fee percentage charged to a facility on invoices
     */
    async facilityControllerUpdatePlatformFeeRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUpdatePlatformFee().');
        }
        if (requestParameters['facilityPlatformFeeDto'] == null) {
            throw new runtime.RequiredError('facilityPlatformFeeDto', 'Required parameter "facilityPlatformFeeDto" was null or undefined when calling facilityControllerUpdatePlatformFee().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/platform-fee`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityPlatformFeeDtoToJSON)(requestParameters['facilityPlatformFeeDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Set the platform fee percentage charged to a facility on invoices
     */
    async facilityControllerUpdatePlatformFee(requestParameters, initOverrides) {
        await this.facilityControllerUpdatePlatformFeeRaw(requestParameters, initOverrides);
    }
    /**
     * Upload or replace a facility profile photo (PNG/JPEG)
     */
    async facilityControllerUploadFacilityPhotoRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerUploadFacilityPhoto().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['facilityPhoto'] != null) {
            formParams.append('facilityPhoto', requestParameters['facilityPhoto']);
        }
        const response = await this.request({
            path: `/facility/{facilityId}/photo`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Upload or replace a facility profile photo (PNG/JPEG)
     */
    async facilityControllerUploadFacilityPhoto(requestParameters, initOverrides) {
        const response = await this.facilityControllerUploadFacilityPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Mark a nurse as verified to work at a facility after confirming onboarding completion
     */
    async facilityControllerVerifyNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityControllerVerifyNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityControllerVerifyNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/nurse/{profileId}/verify`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Mark a nurse as verified to work at a facility after confirming onboarding completion
     */
    async facilityControllerVerifyNurse(requestParameters, initOverrides) {
        await this.facilityControllerVerifyNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Get shift details including assigned nurse, cancellation history, requests, and credential warnings
     */
    async facilityControllerViewShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling facilityControllerViewShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityShiftDetailsDtoFromJSON)(jsonValue));
    }
    /**
     * Get shift details including assigned nurse, cancellation history, requests, and credential warnings
     */
    async facilityControllerViewShift(requestParameters, initOverrides) {
        const response = await this.facilityControllerViewShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update facility interest
     */
    async facilityInterestControllerCreateInterestRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityInterestCreateDto'] == null) {
            throw new runtime.RequiredError('facilityInterestCreateDto', 'Required parameter "facilityInterestCreateDto" was null or undefined when calling facilityInterestControllerCreateInterest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility-interests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilityInterestCreateDtoToJSON)(requestParameters['facilityInterestCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityInterestDtoFromJSON)(jsonValue));
    }
    /**
     * Create or update facility interest
     */
    async facilityInterestControllerCreateInterest(requestParameters, initOverrides) {
        const response = await this.facilityInterestControllerCreateInterestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a facility-specific nurse document from S3 and the database
     */
    async facilityProfileDocumentControllerDeleteDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityProfileDocumentControllerDeleteDocument().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityProfileDocumentControllerDeleteDocument().');
        }
        if (requestParameters['fileName'] == null) {
            throw new runtime.RequiredError('fileName', 'Required parameter "fileName" was null or undefined when calling facilityProfileDocumentControllerDeleteDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility-profile-document/{facilityId}/{profileId}/{fileName}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters['fileName']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a facility-specific nurse document from S3 and the database
     */
    async facilityProfileDocumentControllerDeleteDocument(requestParameters, initOverrides) {
        await this.facilityProfileDocumentControllerDeleteDocumentRaw(requestParameters, initOverrides);
    }
    /**
     * List facility-specific documents uploaded for a nurse with pre-signed S3 download URLs
     */
    async facilityProfileDocumentControllerGetDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityProfileDocumentControllerGetDocuments().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityProfileDocumentControllerGetDocuments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility-profile-document/{facilityId}/{profileId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityProfileDocumentDtoFromJSON));
    }
    /**
     * List facility-specific documents uploaded for a nurse with pre-signed S3 download URLs
     */
    async facilityProfileDocumentControllerGetDocuments(requestParameters, initOverrides) {
        const response = await this.facilityProfileDocumentControllerGetDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload facility-specific documents (PNG, JPG, PDF) for a nurse profile to S3
     */
    async facilityProfileDocumentControllerUploadDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling facilityProfileDocumentControllerUploadDocuments().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling facilityProfileDocumentControllerUploadDocuments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['documents'] != null) {
            requestParameters['documents'].forEach((element) => {
                formParams.append('documents', element);
            });
        }
        const response = await this.request({
            path: `/facility-profile-document/{facilityId}/{profileId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload facility-specific documents (PNG, JPG, PDF) for a nurse profile to S3
     */
    async facilityProfileDocumentControllerUploadDocuments(requestParameters, initOverrides) {
        await this.facilityProfileDocumentControllerUploadDocumentsRaw(requestParameters, initOverrides);
    }
    /**
     * Permanently remove a feature flag and its facility associations
     */
    async featureFlagControllerDeleteFeatureFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['flagKey'] == null) {
            throw new runtime.RequiredError('flagKey', 'Required parameter "flagKey" was null or undefined when calling featureFlagControllerDeleteFeatureFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag/flag/{flagKey}`.replace(`{${"flagKey"}}`, encodeURIComponent(String(requestParameters['flagKey']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently remove a feature flag and its facility associations
     */
    async featureFlagControllerDeleteFeatureFlag(requestParameters, initOverrides) {
        await this.featureFlagControllerDeleteFeatureFlagRaw(requestParameters, initOverrides);
    }
    /**
     * Get active feature flag keys for the authenticated user based on global and facility membership
     */
    async featureFlagControllerGetCurrentUserFeatureFlagsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag/profile/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.UserFeatureFlagsDtoFromJSON)(jsonValue));
    }
    /**
     * Get active feature flag keys for the authenticated user based on global and facility membership
     */
    async featureFlagControllerGetCurrentUserFeatureFlags(initOverrides) {
        const response = await this.featureFlagControllerGetCurrentUserFeatureFlagsRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all feature flags with their active facility scopes
     */
    async featureFlagControllerGetFeatureFlagsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FeatureFlagDtoFromJSON));
    }
    /**
     * List all feature flags with their active facility scopes
     */
    async featureFlagControllerGetFeatureFlags(initOverrides) {
        const response = await this.featureFlagControllerGetFeatureFlagsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get active feature flag keys for a specific profile based on global and facility membership
     */
    async featureFlagControllerGetUserFeatureFlagsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling featureFlagControllerGetUserFeatureFlags().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.UserFeatureFlagsDtoFromJSON)(jsonValue));
    }
    /**
     * Get active feature flag keys for a specific profile based on global and facility membership
     */
    async featureFlagControllerGetUserFeatureFlags(requestParameters, initOverrides) {
        const response = await this.featureFlagControllerGetUserFeatureFlagsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update a feature flag with global or per-facility activation
     */
    async featureFlagControllerUpdateFeatureFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['featureFlagUpdateDto'] == null) {
            throw new runtime.RequiredError('featureFlagUpdateDto', 'Required parameter "featureFlagUpdateDto" was null or undefined when calling featureFlagControllerUpdateFeatureFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flag`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FeatureFlagUpdateDtoToJSON)(requestParameters['featureFlagUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FeatureFlagDtoFromJSON)(jsonValue));
    }
    /**
     * Create or update a feature flag with global or per-facility activation
     */
    async featureFlagControllerUpdateFeatureFlag(requestParameters, initOverrides) {
        const response = await this.featureFlagControllerUpdateFeatureFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a nurse\'s N95 respirator fit test record and documentation URL
     */
    async fitTestControllerGetFitTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling fitTestControllerGetFitTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fit-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FitTestDtoFromJSON)(jsonValue));
    }
    /**
     * Get a nurse\'s N95 respirator fit test record and documentation URL
     */
    async fitTestControllerGetFitTest(requestParameters, initOverrides) {
        const response = await this.fitTestControllerGetFitTestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update a nurse\'s N95 respirator fit test record
     */
    async fitTestControllerUpdateFitTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling fitTestControllerUpdateFitTest().');
        }
        if (requestParameters['fitTestDto'] == null) {
            throw new runtime.RequiredError('fitTestDto', 'Required parameter "fitTestDto" was null or undefined when calling fitTestControllerUpdateFitTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fit-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FitTestDtoToJSON)(requestParameters['fitTestDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Create or update a nurse\'s N95 respirator fit test record
     */
    async fitTestControllerUpdateFitTest(requestParameters, initOverrides) {
        await this.fitTestControllerUpdateFitTestRaw(requestParameters, initOverrides);
    }
    /**
     * Upload N95 respirator fit test documentation (PNG, JPG, PDF) to S3
     */
    async fitTestControllerUploadDocumentationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling fitTestControllerUploadDocumentation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['documentation'] != null) {
            formParams.append('documentation', requestParameters['documentation']);
        }
        const response = await this.request({
            path: `/fit-test/{profileId}/documentation`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload N95 respirator fit test documentation (PNG, JPG, PDF) to S3
     */
    async fitTestControllerUploadDocumentation(requestParameters, initOverrides) {
        await this.fitTestControllerUploadDocumentationRaw(requestParameters, initOverrides);
    }
    /**
     * Geocode a US zip code to latitude/longitude coordinates via Google Maps
     */
    async geoControllerGetLatLngFromZipRaw(requestParameters, initOverrides) {
        if (requestParameters['zipCodeDto'] == null) {
            throw new runtime.RequiredError('zipCodeDto', 'Required parameter "zipCodeDto" was null or undefined when calling geoControllerGetLatLngFromZip().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/geo/lat-lng`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ZipCodeDtoToJSON)(requestParameters['zipCodeDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.LocationDtoFromJSON)(jsonValue));
    }
    /**
     * Geocode a US zip code to latitude/longitude coordinates via Google Maps
     */
    async geoControllerGetLatLngFromZip(requestParameters, initOverrides) {
        const response = await this.geoControllerGetLatLngFromZipRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Reverse geocode latitude/longitude coordinates to a US zip code via Google Maps
     */
    async geoControllerGetZipCodeFromLatLngRaw(requestParameters, initOverrides) {
        if (requestParameters['locationDto'] == null) {
            throw new runtime.RequiredError('locationDto', 'Required parameter "locationDto" was null or undefined when calling geoControllerGetZipCodeFromLatLng().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/geo/zip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.LocationDtoToJSON)(requestParameters['locationDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ZipCodeDtoFromJSON)(jsonValue));
    }
    /**
     * Reverse geocode latitude/longitude coordinates to a US zip code via Google Maps
     */
    async geoControllerGetZipCodeFromLatLng(requestParameters, initOverrides) {
        const response = await this.geoControllerGetZipCodeFromLatLngRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Internal ALB health check endpoint, blocked from external access
     */
    async heartbeatControllerGetHeartbeatRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/heartbeat`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Internal ALB health check endpoint, blocked from external access
     */
    async heartbeatControllerGetHeartbeat(initOverrides) {
        await this.heartbeatControllerGetHeartbeatRaw(initOverrides);
    }
    /**
     * Process HubSpot signup form submission and auto-invite new nurses to the platform
     */
    async hubSpotControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['hubSpotPayloadDto'] == null) {
            throw new runtime.RequiredError('hubSpotPayloadDto', 'Required parameter "hubSpotPayloadDto" was null or undefined when calling hubSpotControllerHandleHubSpotWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/hubspot/signup-form/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.HubSpotPayloadDtoToJSON)(requestParameters['hubSpotPayloadDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process HubSpot signup form submission and auto-invite new nurses to the platform
     */
    async hubSpotControllerHandleHubSpotWebhook(requestParameters, initOverrides) {
        await this.hubSpotControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides);
    }
    /**
     */
    async infectiousDiseaseTestControllerFulfillTestOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerFulfillTestOrder().');
        }
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError('orderId', 'Required parameter "orderId" was null or undefined when calling infectiousDiseaseTestControllerFulfillTestOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/order/{orderId}/fulfill`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestOrderDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerFulfillTestOrder(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerFulfillTestOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTest().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling infectiousDiseaseTestControllerGetTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/test/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTest(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestMinimumValidDateRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTestMinimumValidDate().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling infectiousDiseaseTestControllerGetTestMinimumValidDate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/test/{code}/min-date`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.MinimumValidDateDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestMinimumValidDate(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestMinimumValidDateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTestOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/order`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestOrderDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestOrder(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTestsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerGetTests().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.InfectiousDiseaseTestDtoFromJSON));
    }
    /**
     */
    async infectiousDiseaseTestControllerGetTests(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerGetTestsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerRequestTestOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerRequestTestOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/order`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async infectiousDiseaseTestControllerRequestTestOrder(requestParameters, initOverrides) {
        await this.infectiousDiseaseTestControllerRequestTestOrderRaw(requestParameters, initOverrides);
    }
    /**
     */
    async infectiousDiseaseTestControllerUpdateTestRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerUpdateTest().');
        }
        if (requestParameters['infectiousDiseaseTestUpdateDto'] == null) {
            throw new runtime.RequiredError('infectiousDiseaseTestUpdateDto', 'Required parameter "infectiousDiseaseTestUpdateDto" was null or undefined when calling infectiousDiseaseTestControllerUpdateTest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.InfectiousDiseaseTestUpdateDtoToJSON)(requestParameters['infectiousDiseaseTestUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.InfectiousDiseaseTestDtoFromJSON)(jsonValue));
    }
    /**
     */
    async infectiousDiseaseTestControllerUpdateTest(requestParameters, initOverrides) {
        const response = await this.infectiousDiseaseTestControllerUpdateTestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async infectiousDiseaseTestControllerUploadTestCardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling infectiousDiseaseTestControllerUploadTestCard().');
        }
        if (requestParameters['testId'] == null) {
            throw new runtime.RequiredError('testId', 'Required parameter "testId" was null or undefined when calling infectiousDiseaseTestControllerUploadTestCard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['testCard'] != null) {
            formParams.append('testCard', requestParameters['testCard']);
        }
        const response = await this.request({
            path: `/infectious-disease-test/{profileId}/test-card/{testId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"testId"}}`, encodeURIComponent(String(requestParameters['testId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async infectiousDiseaseTestControllerUploadTestCard(requestParameters, initOverrides) {
        await this.infectiousDiseaseTestControllerUploadTestCardRaw(requestParameters, initOverrides);
    }
    /**
     * Add a new state/territory jurisdiction to the system
     */
    async jurisdictionControllerCreateJurisdictionRaw(requestParameters, initOverrides) {
        if (requestParameters['jurisdictionDto'] == null) {
            throw new runtime.RequiredError('jurisdictionDto', 'Required parameter "jurisdictionDto" was null or undefined when calling jurisdictionControllerCreateJurisdiction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.JurisdictionDtoToJSON)(requestParameters['jurisdictionDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a new state/territory jurisdiction to the system
     */
    async jurisdictionControllerCreateJurisdiction(requestParameters, initOverrides) {
        await this.jurisdictionControllerCreateJurisdictionRaw(requestParameters, initOverrides);
    }
    /**
     * Get jurisdiction details including associated nurse license compacts
     */
    async jurisdictionControllerGetJurisdictionRaw(requestParameters, initOverrides) {
        if (requestParameters['abbreviation'] == null) {
            throw new runtime.RequiredError('abbreviation', 'Required parameter "abbreviation" was null or undefined when calling jurisdictionControllerGetJurisdiction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction/{abbreviation}`.replace(`{${"abbreviation"}}`, encodeURIComponent(String(requestParameters['abbreviation']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.JurisdictionDetailsDtoFromJSON)(jsonValue));
    }
    /**
     * Get jurisdiction details including associated nurse license compacts
     */
    async jurisdictionControllerGetJurisdiction(requestParameters, initOverrides) {
        const response = await this.jurisdictionControllerGetJurisdictionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List US state/territory jurisdictions, searchable by name or abbreviation
     */
    async jurisdictionControllerListJurisdictionsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.JurisdictionDtoFromJSON));
    }
    /**
     * List US state/territory jurisdictions, searchable by name or abbreviation
     */
    async jurisdictionControllerListJurisdictions(requestParameters = {}, initOverrides) {
        const response = await this.jurisdictionControllerListJurisdictionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update the name of an existing jurisdiction
     */
    async jurisdictionControllerUpdateJurisdictionRaw(requestParameters, initOverrides) {
        if (requestParameters['abbreviation'] == null) {
            throw new runtime.RequiredError('abbreviation', 'Required parameter "abbreviation" was null or undefined when calling jurisdictionControllerUpdateJurisdiction().');
        }
        if (requestParameters['jurisdictionDto'] == null) {
            throw new runtime.RequiredError('jurisdictionDto', 'Required parameter "jurisdictionDto" was null or undefined when calling jurisdictionControllerUpdateJurisdiction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jurisdiction/{abbreviation}`.replace(`{${"abbreviation"}}`, encodeURIComponent(String(requestParameters['abbreviation']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.JurisdictionDtoToJSON)(requestParameters['jurisdictionDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update the name of an existing jurisdiction
     */
    async jurisdictionControllerUpdateJurisdiction(requestParameters, initOverrides) {
        await this.jurisdictionControllerUpdateJurisdictionRaw(requestParameters, initOverrides);
    }
    /**
     * Look up nurse licenses by NCSBN ID for Nursys verification batch processing
     */
    async licenseControllerGetLicensesByNcsbnIdRaw(requestParameters, initOverrides) {
        if (requestParameters['ncsbnIds'] == null) {
            throw new runtime.RequiredError('ncsbnIds', 'Required parameter "ncsbnIds" was null or undefined when calling licenseControllerGetLicensesByNcsbnId().');
        }
        const queryParameters = {};
        if (requestParameters['ncsbnIds'] != null) {
            queryParameters['ncsbnIds'] = requestParameters['ncsbnIds'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/by-ncsbnId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseBatchDtoFromJSON));
    }
    /**
     * Look up nurse licenses by NCSBN ID for Nursys verification batch processing
     */
    async licenseControllerGetLicensesByNcsbnId(requestParameters, initOverrides) {
        const response = await this.licenseControllerGetLicensesByNcsbnIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List profile ID and NCSBN ID pairs for all nurses registered with Nursys
     */
    async licenseControllerGetNcsbnProfilesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/ncsbn-profiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NcsbnProfileDtoFromJSON));
    }
    /**
     * List profile ID and NCSBN ID pairs for all nurses registered with Nursys
     */
    async licenseControllerGetNcsbnProfiles(initOverrides) {
        const response = await this.licenseControllerGetNcsbnProfilesRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all nurse licenses pending Nursys verification with nurse profile details
     */
    async licenseControllerGetUnverifiedLicensesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/unverified`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseBatchDtoFromJSON));
    }
    /**
     * List all nurse licenses pending Nursys verification with nurse profile details
     */
    async licenseControllerGetUnverifiedLicenses(initOverrides) {
        const response = await this.licenseControllerGetUnverifiedLicensesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Update a nurse license verification status, expiration date, and compact status from Nursys results
     */
    async licenseControllerUpdateLicenseStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling licenseControllerUpdateLicenseStatus().');
        }
        if (requestParameters['licenseStatusUpdateDto'] == null) {
            throw new runtime.RequiredError('licenseStatusUpdateDto', 'Required parameter "licenseStatusUpdateDto" was null or undefined when calling licenseControllerUpdateLicenseStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/license/nurse/{licenseId}`.replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.LicenseStatusUpdateDtoToJSON)(requestParameters['licenseStatusUpdateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a nurse license verification status, expiration date, and compact status from Nursys results
     */
    async licenseControllerUpdateLicenseStatus(requestParameters, initOverrides) {
        await this.licenseControllerUpdateLicenseStatusRaw(requestParameters, initOverrides);
    }
    /**
     * Add an internal admin note to a facility
     */
    async noteControllerCreateFacilityNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling noteControllerCreateFacilityNote().');
        }
        if (requestParameters['profileNoteCreateDto'] == null) {
            throw new runtime.RequiredError('profileNoteCreateDto', 'Required parameter "profileNoteCreateDto" was null or undefined when calling noteControllerCreateFacilityNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileNoteCreateDtoToJSON)(requestParameters['profileNoteCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityNoteDtoFromJSON)(jsonValue));
    }
    /**
     * Add an internal admin note to a facility
     */
    async noteControllerCreateFacilityNote(requestParameters, initOverrides) {
        const response = await this.noteControllerCreateFacilityNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add an internal admin note to a nurse profile
     */
    async noteControllerCreateProfileNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling noteControllerCreateProfileNote().');
        }
        if (requestParameters['profileNoteCreateDto'] == null) {
            throw new runtime.RequiredError('profileNoteCreateDto', 'Required parameter "profileNoteCreateDto" was null or undefined when calling noteControllerCreateProfileNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileNoteCreateDtoToJSON)(requestParameters['profileNoteCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileNoteDtoFromJSON)(jsonValue));
    }
    /**
     * Add an internal admin note to a nurse profile
     */
    async noteControllerCreateProfileNote(requestParameters, initOverrides) {
        const response = await this.noteControllerCreateProfileNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove a file attachment from an admin note and delete it from S3
     */
    async noteControllerDeleteAttachmentRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerDeleteAttachment().');
        }
        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter "attachmentId" was null or undefined when calling noteControllerDeleteAttachment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{noteId}/attachments/{attachmentId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a file attachment from an admin note and delete it from S3
     */
    async noteControllerDeleteAttachment(requestParameters, initOverrides) {
        await this.noteControllerDeleteAttachmentRaw(requestParameters, initOverrides);
    }
    /**
     * Delete a note (only the original author can delete)
     */
    async noteControllerDeleteNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerDeleteNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a note (only the original author can delete)
     */
    async noteControllerDeleteNote(requestParameters, initOverrides) {
        await this.noteControllerDeleteNoteRaw(requestParameters, initOverrides);
    }
    /**
     * Get internal admin notes on a facility, sorted newest first
     */
    async noteControllerGetFacilityNotesRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling noteControllerGetFacilityNotes().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityNoteDtoFromJSON));
    }
    /**
     * Get internal admin notes on a facility, sorted newest first
     */
    async noteControllerGetFacilityNotes(requestParameters, initOverrides) {
        const response = await this.noteControllerGetFacilityNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get internal admin notes on a nurse profile, sorted newest first
     */
    async noteControllerGetProfileNotesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling noteControllerGetProfileNotes().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ProfileNoteDtoFromJSON));
    }
    /**
     * Get internal admin notes on a nurse profile, sorted newest first
     */
    async noteControllerGetProfileNotes(requestParameters, initOverrides) {
        const response = await this.noteControllerGetProfileNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a note (only the original author can edit)
     */
    async noteControllerUpdateNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerUpdateNote().');
        }
        if (requestParameters['profileNoteCreateDto'] == null) {
            throw new runtime.RequiredError('profileNoteCreateDto', 'Required parameter "profileNoteCreateDto" was null or undefined when calling noteControllerUpdateNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileNoteCreateDtoToJSON)(requestParameters['profileNoteCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileNoteDtoFromJSON)(jsonValue));
    }
    /**
     * Edit a note (only the original author can edit)
     */
    async noteControllerUpdateNote(requestParameters, initOverrides) {
        const response = await this.noteControllerUpdateNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload file attachments (images, PDFs, docs) to an admin note
     */
    async noteControllerUploadAttachmentsRaw(requestParameters, initOverrides) {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError('noteId', 'Required parameter "noteId" was null or undefined when calling noteControllerUploadAttachments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['attachments'] != null) {
            requestParameters['attachments'].forEach((element) => {
                formParams.append('attachments', element);
            });
        }
        const response = await this.request({
            path: `/note/{noteId}/attachments`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload file attachments (images, PDFs, docs) to an admin note
     */
    async noteControllerUploadAttachments(requestParameters, initOverrides) {
        await this.noteControllerUploadAttachmentsRaw(requestParameters, initOverrides);
    }
    /**
     * Get the specialties the logged-in user wants to be notified about at this facility
     */
    async notificationSpecialtyControllerGetPreferenceRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling notificationSpecialtyControllerGetPreference().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/notification-specialty`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NotificationSpecialtyDtoFromJSON)(jsonValue));
    }
    /**
     * Get the specialties the logged-in user wants to be notified about at this facility
     */
    async notificationSpecialtyControllerGetPreference(requestParameters, initOverrides) {
        const response = await this.notificationSpecialtyControllerGetPreferenceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Replace the specialties the logged-in user wants to be notified about at this facility
     */
    async notificationSpecialtyControllerUpdatePreferenceRaw(requestParameters, initOverrides) {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling notificationSpecialtyControllerUpdatePreference().');
        }
        if (requestParameters['notificationSpecialtyUpdateDto'] == null) {
            throw new runtime.RequiredError('notificationSpecialtyUpdateDto', 'Required parameter "notificationSpecialtyUpdateDto" was null or undefined when calling notificationSpecialtyControllerUpdatePreference().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/facility/{facilityId}/notification-specialty`.replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NotificationSpecialtyUpdateDtoToJSON)(requestParameters['notificationSpecialtyUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NotificationSpecialtyDtoFromJSON)(jsonValue));
    }
    /**
     * Replace the specialties the logged-in user wants to be notified about at this facility
     */
    async notificationSpecialtyControllerUpdatePreference(requestParameters, initOverrides) {
        const response = await this.notificationSpecialtyControllerUpdatePreferenceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the logged-in user\'s notification topics, grouped into sections and filtered to their roles
     */
    async notificationSubscriptionControllerGetSubscriptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notification/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NotificationSubscriptionsDtoFromJSON)(jsonValue));
    }
    /**
     * Get the logged-in user\'s notification topics, grouped into sections and filtered to their roles
     */
    async notificationSubscriptionControllerGetSubscriptions(initOverrides) {
        const response = await this.notificationSubscriptionControllerGetSubscriptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Update the logged-in user\'s notification topic subscriptions and return the resulting state
     */
    async notificationSubscriptionControllerUpdateSubscriptionsRaw(requestParameters, initOverrides) {
        if (requestParameters['notificationSubscriptionUpdateDto'] == null) {
            throw new runtime.RequiredError('notificationSubscriptionUpdateDto', 'Required parameter "notificationSubscriptionUpdateDto" was null or undefined when calling notificationSubscriptionControllerUpdateSubscriptions().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/notification/subscription`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NotificationSubscriptionUpdateDtoToJSON)(requestParameters['notificationSubscriptionUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NotificationSubscriptionsDtoFromJSON)(jsonValue));
    }
    /**
     * Update the logged-in user\'s notification topic subscriptions and return the resulting state
     */
    async notificationSubscriptionControllerUpdateSubscriptions(requestParameters, initOverrides) {
        const response = await this.notificationSubscriptionControllerUpdateSubscriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Accept one or more shift requests sent by a facility after verifying nurse is qualified
     */
    async nurseControllerAcceptFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['bulkShiftAcceptDto'] == null) {
            throw new runtime.RequiredError('bulkShiftAcceptDto', 'Required parameter "bulkShiftAcceptDto" was null or undefined when calling nurseControllerAcceptFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/shifts`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.BulkShiftAcceptDtoToJSON)(requestParameters['bulkShiftAcceptDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Accept one or more shift requests sent by a facility after verifying nurse is qualified
     */
    async nurseControllerAcceptFacilityRequest(requestParameters, initOverrides) {
        await this.nurseControllerAcceptFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Register nurse licenses and submit them to Nursys for verification
     */
    async nurseControllerCreateLicenseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerCreateLicense().');
        }
        if (requestParameters['createNurseLicensesDto'] == null) {
            throw new runtime.RequiredError('createNurseLicensesDto', 'Required parameter "createNurseLicensesDto" was null or undefined when calling nurseControllerCreateLicense().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateNurseLicensesDtoToJSON)(requestParameters['createNurseLicensesDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Register nurse licenses and submit them to Nursys for verification
     */
    async nurseControllerCreateLicense(requestParameters, initOverrides) {
        await this.nurseControllerCreateLicenseRaw(requestParameters, initOverrides);
    }
    /**
     * Remove a license and its Nursys transaction history from a nurse profile
     */
    async nurseControllerDeleteLicenseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerDeleteLicense().');
        }
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling nurseControllerDeleteLicense().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license/{licenseId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a license and its Nursys transaction history from a nurse profile
     */
    async nurseControllerDeleteLicense(requestParameters, initOverrides) {
        await this.nurseControllerDeleteLicenseRaw(requestParameters, initOverrides);
    }
    /**
     * Get pending facility requests and shifts/orientations missing time submissions
     */
    async nurseControllerGetActionsNeededCountsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetActionsNeededCounts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/actions-needed-counts`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ActionsNeededCountsDtoFromJSON)(jsonValue));
    }
    /**
     * Get pending facility requests and shifts/orientations missing time submissions
     */
    async nurseControllerGetActionsNeededCounts(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetActionsNeededCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get signed confidentiality agreement or generate an unsigned one from template
     */
    async nurseControllerGetConfidentialityAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetConfidentialityAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/confidentiality-agreement`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ConfidentialityAgreementDtoFromJSON)(jsonValue));
    }
    /**
     * Get signed confidentiality agreement or generate an unsigned one from template
     */
    async nurseControllerGetConfidentialityAgreement(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetConfidentialityAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get signed offer letter or generate an unsigned one from template
     */
    async nurseControllerGetContractRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetContract().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/contract`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.EmploymentContractDtoFromJSON)(jsonValue));
    }
    /**
     * Get signed offer letter or generate an unsigned one from template
     */
    async nurseControllerGetContract(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetContractRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Check onboarding progress for the current user across all requirements (licenses, background check, certifications, etc.)
     */
    async nurseControllerGetCurrentUserProfileCompletenessRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/me/profile-completeness`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NurseProfileCompletenessDtoFromJSON)(jsonValue));
    }
    /**
     * Check onboarding progress for the current user across all requirements (licenses, background check, certifications, etc.)
     */
    async nurseControllerGetCurrentUserProfileCompleteness(initOverrides) {
        const response = await this.nurseControllerGetCurrentUserProfileCompletenessRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get all licenses for a nurse including Nursys verification history
     */
    async nurseControllerGetLicensesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetLicenses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseDtoFromJSON));
    }
    /**
     * Get all licenses for a nurse including Nursys verification history
     */
    async nurseControllerGetLicenses(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetLicensesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get electronic medical record systems a nurse has experience with
     */
    async nurseControllerGetNurseEmrsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetNurseEmrs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/emr`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ElectronicMedicalRecordSystemDtoFromJSON));
    }
    /**
     * Get electronic medical record systems a nurse has experience with
     */
    async nurseControllerGetNurseEmrs(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetNurseEmrsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Check onboarding progress for a nurse across all requirements (licenses, background check, certifications, etc.)
     */
    async nurseControllerGetProfileCompletenessRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerGetProfileCompleteness().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/profile-completeness`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NurseProfileCompletenessDtoFromJSON)(jsonValue));
    }
    /**
     * Check onboarding progress for a nurse across all requirements (licenses, background check, certifications, etc.)
     */
    async nurseControllerGetProfileCompleteness(requestParameters, initOverrides) {
        const response = await this.nurseControllerGetProfileCompletenessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List shifts assigned or requested for a nurse with request status, proposals, and credential warnings
     */
    async nurseControllerListShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerListShifts().');
        }
        const queryParameters = {};
        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'].toISOString();
        }
        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'].toISOString();
        }
        if (requestParameters['requestStatus'] != null) {
            queryParameters['requestStatus'] = requestParameters['requestStatus'];
        }
        if (requestParameters['requestedBy'] != null) {
            queryParameters['requestedBy'] = requestParameters['requestedBy'];
        }
        if (requestParameters['hasTimeLogged'] != null) {
            queryParameters['hasTimeLogged'] = requestParameters['hasTimeLogged'];
        }
        if (requestParameters['payPeriodStart'] != null) {
            queryParameters['payPeriodStart'] = requestParameters['payPeriodStart'].toISOString();
        }
        if (requestParameters['shiftStatus'] != null) {
            queryParameters['shiftStatus'] = requestParameters['shiftStatus'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/shift`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfRequestedShiftDtoFromJSON)(jsonValue));
    }
    /**
     * List shifts assigned or requested for a nurse with request status, proposals, and credential warnings
     */
    async nurseControllerListShifts(requestParameters, initOverrides) {
        const response = await this.nurseControllerListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Report a shift missing from a pay period; emails nurse support
     */
    async nurseControllerReportMissingShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerReportMissingShift().');
        }
        if (requestParameters['missingShiftReportDto'] == null) {
            throw new runtime.RequiredError('missingShiftReportDto', 'Required parameter "missingShiftReportDto" was null or undefined when calling nurseControllerReportMissingShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/missing-shift-report`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.MissingShiftReportDtoToJSON)(requestParameters['missingShiftReportDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Report a shift missing from a pay period; emails nurse support
     */
    async nurseControllerReportMissingShift(requestParameters, initOverrides) {
        await this.nurseControllerReportMissingShiftRaw(requestParameters, initOverrides);
    }
    /**
     * Delete a signed confidentiality agreement so the nurse can re-sign
     */
    async nurseControllerResetConfidentialityAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerResetConfidentialityAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/confidentiality-agreement`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a signed confidentiality agreement so the nurse can re-sign
     */
    async nurseControllerResetConfidentialityAgreement(requestParameters, initOverrides) {
        await this.nurseControllerResetConfidentialityAgreementRaw(requestParameters, initOverrides);
    }
    /**
     * Delete a signed offer letter so the nurse can re-sign
     */
    async nurseControllerResetContractRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerResetContract().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/contract`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a signed offer letter so the nurse can re-sign
     */
    async nurseControllerResetContract(requestParameters, initOverrides) {
        await this.nurseControllerResetContractRaw(requestParameters, initOverrides);
    }
    /**
     * Submit a license back to Nursys for re-verification and reset its status to unverified
     */
    async nurseControllerReverifyLicenseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerReverifyLicense().');
        }
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling nurseControllerReverifyLicense().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license/{licenseId}/reverify`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit a license back to Nursys for re-verification and reset its status to unverified
     */
    async nurseControllerReverifyLicense(requestParameters, initOverrides) {
        await this.nurseControllerReverifyLicenseRaw(requestParameters, initOverrides);
    }
    /**
     * Sign the confidentiality agreement after verifying tuberculosis and background check are complete
     */
    async nurseControllerSignConfidentialityAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerSignConfidentialityAgreement().');
        }
        if (requestParameters['signConfidentialityAgreementDto'] == null) {
            throw new runtime.RequiredError('signConfidentialityAgreementDto', 'Required parameter "signConfidentialityAgreementDto" was null or undefined when calling nurseControllerSignConfidentialityAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/confidentiality-agreement`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SignConfidentialityAgreementDtoToJSON)(requestParameters['signConfidentialityAgreementDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ConfidentialityAgreementDtoFromJSON)(jsonValue));
    }
    /**
     * Sign the confidentiality agreement after verifying tuberculosis and background check are complete
     */
    async nurseControllerSignConfidentialityAgreement(requestParameters, initOverrides) {
        const response = await this.nurseControllerSignConfidentialityAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Sign the offer letter after verifying tuberculosis and background check are complete
     */
    async nurseControllerSignContractRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerSignContract().');
        }
        if (requestParameters['signEmploymentContractDto'] == null) {
            throw new runtime.RequiredError('signEmploymentContractDto', 'Required parameter "signEmploymentContractDto" was null or undefined when calling nurseControllerSignContract().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/contract`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SignEmploymentContractDtoToJSON)(requestParameters['signEmploymentContractDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.EmploymentContractDtoFromJSON)(jsonValue));
    }
    /**
     * Sign the offer letter after verifying tuberculosis and background check are complete
     */
    async nurseControllerSignContract(requestParameters, initOverrides) {
        const response = await this.nurseControllerSignContractRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Replace the list of electronic medical record systems a nurse has experience with
     */
    async nurseControllerUpdateNurseEmrsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerUpdateNurseEmrs().');
        }
        if (requestParameters['electronicMedicalRecordSystemsUpdateDto'] == null) {
            throw new runtime.RequiredError('electronicMedicalRecordSystemsUpdateDto', 'Required parameter "electronicMedicalRecordSystemsUpdateDto" was null or undefined when calling nurseControllerUpdateNurseEmrs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/emr`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ElectronicMedicalRecordSystemsUpdateDtoToJSON)(requestParameters['electronicMedicalRecordSystemsUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ElectronicMedicalRecordSystemDtoFromJSON));
    }
    /**
     * Replace the list of electronic medical record systems a nurse has experience with
     */
    async nurseControllerUpdateNurseEmrs(requestParameters, initOverrides) {
        const response = await this.nurseControllerUpdateNurseEmrsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update licenses with verified status from Nursys lookup results
     */
    async nurseControllerUpsertVerifiedLicensesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling nurseControllerUpsertVerifiedLicenses().');
        }
        if (requestParameters['createVerifiedNurseLicensesDto'] == null) {
            throw new runtime.RequiredError('createVerifiedNurseLicensesDto', 'Required parameter "createVerifiedNurseLicensesDto" was null or undefined when calling nurseControllerUpsertVerifiedLicenses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse/{profileId}/license`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateVerifiedNurseLicensesDtoToJSON)(requestParameters['createVerifiedNurseLicensesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseDtoFromJSON));
    }
    /**
     * Create or update licenses with verified status from Nursys lookup results
     */
    async nurseControllerUpsertVerifiedLicenses(requestParameters, initOverrides) {
        const response = await this.nurseControllerUpsertVerifiedLicensesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Register a new multi-state nurse license compact
     */
    async nurseLicenseCompactControllerCreateNurseLicenseCompactRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseLicenseCompactDto'] == null) {
            throw new runtime.RequiredError('nurseLicenseCompactDto', 'Required parameter "nurseLicenseCompactDto" was null or undefined when calling nurseLicenseCompactControllerCreateNurseLicenseCompact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseLicenseCompactDtoToJSON)(requestParameters['nurseLicenseCompactDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Register a new multi-state nurse license compact
     */
    async nurseLicenseCompactControllerCreateNurseLicenseCompact(requestParameters, initOverrides) {
        await this.nurseLicenseCompactControllerCreateNurseLicenseCompactRaw(requestParameters, initOverrides);
    }
    /**
     * Get a license compact with its member jurisdictions
     */
    async nurseLicenseCompactControllerGetNurseLicenseCompactRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling nurseLicenseCompactControllerGetNurseLicenseCompact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.NurseLicenseCompactDetailsDtoFromJSON)(jsonValue));
    }
    /**
     * Get a license compact with its member jurisdictions
     */
    async nurseLicenseCompactControllerGetNurseLicenseCompact(requestParameters, initOverrides) {
        const response = await this.nurseLicenseCompactControllerGetNurseLicenseCompactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List multi-state nurse license compacts (e.g. NLC, ASLC), searchable by name or abbreviation
     */
    async nurseLicenseCompactControllerListNurseLicenseCompactsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseLicenseCompactDtoFromJSON));
    }
    /**
     * List multi-state nurse license compacts (e.g. NLC, ASLC), searchable by name or abbreviation
     */
    async nurseLicenseCompactControllerListNurseLicenseCompacts(requestParameters = {}, initOverrides) {
        const response = await this.nurseLicenseCompactControllerListNurseLicenseCompactsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a license compact name, abbreviation, and member jurisdictions
     */
    async nurseLicenseCompactControllerUpdateNurseLicenseCompactRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling nurseLicenseCompactControllerUpdateNurseLicenseCompact().');
        }
        if (requestParameters['nurseLicenseCompactUpdateDto'] == null) {
            throw new runtime.RequiredError('nurseLicenseCompactUpdateDto', 'Required parameter "nurseLicenseCompactUpdateDto" was null or undefined when calling nurseLicenseCompactControllerUpdateNurseLicenseCompact().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-license-compact/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseLicenseCompactUpdateDtoToJSON)(requestParameters['nurseLicenseCompactUpdateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update a license compact name, abbreviation, and member jurisdictions
     */
    async nurseLicenseCompactControllerUpdateNurseLicenseCompact(requestParameters, initOverrides) {
        await this.nurseLicenseCompactControllerUpdateNurseLicenseCompactRaw(requestParameters, initOverrides);
    }
    /**
     * Remove state practice authorizations for a nurse, optionally filtered by specific states
     */
    async nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizations().');
        }
        const queryParameters = {};
        if (requestParameters['states'] != null) {
            queryParameters['states'] = requestParameters['states'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-state-practice-authorization/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove state practice authorizations for a nurse, optionally filtered by specific states
     */
    async nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizations(requestParameters, initOverrides) {
        await this.nurseStatePracticeAuthorizationControllerDeleteNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides);
    }
    /**
     * List states where a nurse is authorized to practice based on license compact status
     */
    async nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-state-practice-authorization/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AuthorizedStateDtoFromJSON));
    }
    /**
     * List states where a nurse is authorized to practice based on license compact status
     */
    async nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizations(requestParameters, initOverrides) {
        const response = await this.nurseStatePracticeAuthorizationControllerGetNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Replace all state practice authorizations for a nurse based on Nursys license verification results
     */
    async nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizations().');
        }
        if (requestParameters['updateNurseStatePracticeAuthorizationsDto'] == null) {
            throw new runtime.RequiredError('updateNurseStatePracticeAuthorizationsDto', 'Required parameter "updateNurseStatePracticeAuthorizationsDto" was null or undefined when calling nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nurse-state-practice-authorization/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.UpdateNurseStatePracticeAuthorizationsDtoToJSON)(requestParameters['updateNurseStatePracticeAuthorizationsDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Replace all state practice authorizations for a nurse based on Nursys license verification results
     */
    async nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizations(requestParameters, initOverrides) {
        await this.nurseStatePracticeAuthorizationControllerUpdateNurseStatePracticeAuthorizationsRaw(requestParameters, initOverrides);
    }
    /**
     * Record a Nursys license verification batch transaction with associated license IDs
     */
    async nursysControllerCreateNursysTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters['createNursysTransactionDto'] == null) {
            throw new runtime.RequiredError('createNursysTransactionDto', 'Required parameter "createNursysTransactionDto" was null or undefined when calling nursysControllerCreateNursysTransaction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateNursysTransactionDtoToJSON)(requestParameters['createNursysTransactionDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record a Nursys license verification batch transaction with associated license IDs
     */
    async nursysControllerCreateNursysTransaction(requestParameters, initOverrides) {
        await this.nursysControllerCreateNursysTransactionRaw(requestParameters, initOverrides);
    }
    /**
     * List unprocessed Nursys transactions with nurse license and profile details
     */
    async nursysControllerGetPendingNursysTransactionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction/pending`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NursysTransactionDtoFromJSON));
    }
    /**
     * List unprocessed Nursys transactions with nurse license and profile details
     */
    async nursysControllerGetPendingNursysTransactions(initOverrides) {
        const response = await this.nursysControllerGetPendingNursysTransactionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Record the Nursys verification result for an individual license within a transaction
     */
    async nursysControllerUpdateLicenseNursysTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError('licenseId', 'Required parameter "licenseId" was null or undefined when calling nursysControllerUpdateLicenseNursysTransaction().');
        }
        if (requestParameters['transactionId'] == null) {
            throw new runtime.RequiredError('transactionId', 'Required parameter "transactionId" was null or undefined when calling nursysControllerUpdateLicenseNursysTransaction().');
        }
        if (requestParameters['licenseNursysTransactionUpdateStatusDto'] == null) {
            throw new runtime.RequiredError('licenseNursysTransactionUpdateStatusDto', 'Required parameter "licenseNursysTransactionUpdateStatusDto" was null or undefined when calling nursysControllerUpdateLicenseNursysTransaction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction/{transactionId}/license/{licenseId}`.replace(`{${"licenseId"}}`, encodeURIComponent(String(requestParameters['licenseId']))).replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters['transactionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.LicenseNursysTransactionUpdateStatusDtoToJSON)(requestParameters['licenseNursysTransactionUpdateStatusDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record the Nursys verification result for an individual license within a transaction
     */
    async nursysControllerUpdateLicenseNursysTransaction(requestParameters, initOverrides) {
        await this.nursysControllerUpdateLicenseNursysTransactionRaw(requestParameters, initOverrides);
    }
    /**
     * Record Nursys batch transaction processing result and status
     */
    async nursysControllerUpdateNursysTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters['transactionId'] == null) {
            throw new runtime.RequiredError('transactionId', 'Required parameter "transactionId" was null or undefined when calling nursysControllerUpdateNursysTransaction().');
        }
        if (requestParameters['nursysTransactionUpdateDto'] == null) {
            throw new runtime.RequiredError('nursysTransactionUpdateDto', 'Required parameter "nursysTransactionUpdateDto" was null or undefined when calling nursysControllerUpdateNursysTransaction().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nursys/transaction/{transactionId}`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters['transactionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NursysTransactionUpdateDtoToJSON)(requestParameters['nursysTransactionUpdateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record Nursys batch transaction processing result and status
     */
    async nursysControllerUpdateNursysTransaction(requestParameters, initOverrides) {
        await this.nursysControllerUpdateNursysTransactionRaw(requestParameters, initOverrides);
    }
    /**
     * Archive an orientation opportunity (soft delete; drops it from the active list without notifying nurses)
     */
    async orientationOpportunityControllerArchiveOrientationOpportunityRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerArchiveOrientationOpportunity().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Archive an orientation opportunity (soft delete; drops it from the active list without notifying nurses)
     */
    async orientationOpportunityControllerArchiveOrientationOpportunity(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerArchiveOrientationOpportunityRaw(requestParameters, initOverrides);
    }
    /**
     * Post a new orientation opportunity (interest-gathering posting) for a facility with sessions, rates, and optional stipends
     */
    async orientationOpportunityControllerCreateOrientationOpportunityRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationOpportunityCreateDto'] == null) {
            throw new runtime.RequiredError('orientationOpportunityCreateDto', 'Required parameter "orientationOpportunityCreateDto" was null or undefined when calling orientationOpportunityControllerCreateOrientationOpportunity().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationOpportunityCreateDtoToJSON)(requestParameters['orientationOpportunityCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationOpportunityDtoFromJSON)(jsonValue));
    }
    /**
     * Post a new orientation opportunity (interest-gathering posting) for a facility with sessions, rates, and optional stipends
     */
    async orientationOpportunityControllerCreateOrientationOpportunity(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerCreateOrientationOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Decline a nurse’s pending request for an orientation opportunity
     */
    async orientationOpportunityControllerDeclineOrientationOpportunityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerDeclineOrientationOpportunityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerDeclineOrientationOpportunityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/nurse/{profileId}/decline`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Decline a nurse’s pending request for an orientation opportunity
     */
    async orientationOpportunityControllerDeclineOrientationOpportunityRequest(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerDeclineOrientationOpportunityRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Delete a previously uploaded orientation document for a nurse on an orientation opportunity
     */
    async orientationOpportunityControllerDeleteOrientationOpportunityDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerDeleteOrientationOpportunityDocument().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerDeleteOrientationOpportunityDocument().');
        }
        if (requestParameters['storedDocumentId'] == null) {
            throw new runtime.RequiredError('storedDocumentId', 'Required parameter "storedDocumentId" was null or undefined when calling orientationOpportunityControllerDeleteOrientationOpportunityDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/document/{profileId}/{storedDocumentId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"storedDocumentId"}}`, encodeURIComponent(String(requestParameters['storedDocumentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a previously uploaded orientation document for a nurse on an orientation opportunity
     */
    async orientationOpportunityControllerDeleteOrientationOpportunityDocument(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerDeleteOrientationOpportunityDocumentRaw(requestParameters, initOverrides);
    }
    /**
     * Draft an orientation posting description from the answers a facility gave about the position
     */
    async orientationOpportunityControllerGenerateOrientationDescriptionRaw(requestParameters, initOverrides) {
        if (requestParameters['generateDescriptionDto'] == null) {
            throw new runtime.RequiredError('generateDescriptionDto', 'Required parameter "generateDescriptionDto" was null or undefined when calling orientationOpportunityControllerGenerateOrientationDescription().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/generate-description`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.GenerateDescriptionDtoToJSON)(requestParameters['generateDescriptionDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.GeneratedDescriptionDtoFromJSON)(jsonValue));
    }
    /**
     * Draft an orientation posting description from the answers a facility gave about the position
     */
    async orientationOpportunityControllerGenerateOrientationDescription(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerGenerateOrientationDescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a single orientation opportunity by id (facility-member or admin view)
     */
    async orientationOpportunityControllerGetOrientationOpportunityRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerGetOrientationOpportunity().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationOpportunityDtoFromJSON)(jsonValue));
    }
    /**
     * Get a single orientation opportunity by id (facility-member or admin view)
     */
    async orientationOpportunityControllerGetOrientationOpportunity(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerGetOrientationOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a single orientation opportunity from the nurse\'s perspective (own request and stipend qualification; aggregate metrics omitted)
     */
    async orientationOpportunityControllerGetOrientationOpportunityForNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerGetOrientationOpportunityForNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerGetOrientationOpportunityForNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/nurse/{profileId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationOpportunityNurseDetailsDtoFromJSON)(jsonValue));
    }
    /**
     * Get a single orientation opportunity from the nurse\'s perspective (own request and stipend qualification; aggregate metrics omitted)
     */
    async orientationOpportunityControllerGetOrientationOpportunityForNurse(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerGetOrientationOpportunityForNurseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List matched nurses for an orientation opportunity, including who has requested, been declined, or withdrawn
     */
    async orientationOpportunityControllerGetOrientationOpportunityMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerGetOrientationOpportunityMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/matches`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationOpportunityMatchDtoFromJSON));
    }
    /**
     * List matched nurses for an orientation opportunity, including who has requested, been declined, or withdrawn
     */
    async orientationOpportunityControllerGetOrientationOpportunityMatches(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerGetOrientationOpportunityMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List shifts scheduled from an orientation opportunity, with the assigned nurse and times
     */
    async orientationOpportunityControllerGetOrientationOpportunityScheduledShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerGetOrientationOpportunityScheduledShifts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/shifts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationOpportunityScheduledShiftDtoFromJSON));
    }
    /**
     * List shifts scheduled from an orientation opportunity, with the assigned nurse and times
     */
    async orientationOpportunityControllerGetOrientationOpportunityScheduledShifts(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerGetOrientationOpportunityScheduledShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List orientation opportunities for a facility (admins may omit facilityId to list across facilities)
     */
    async orientationOpportunityControllerListOrientationOpportunitiesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = requestParameters['startDateFrom'];
        }
        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = requestParameters['startDateTo'];
        }
        if (requestParameters['minCost'] != null) {
            queryParameters['minCost'] = requestParameters['minCost'];
        }
        if (requestParameters['maxCost'] != null) {
            queryParameters['maxCost'] = requestParameters['maxCost'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['postedByProfileIds'] != null) {
            queryParameters['postedByProfileIds'] = requestParameters['postedByProfileIds'];
        }
        if (requestParameters['specialtyCodes'] != null) {
            queryParameters['specialtyCodes'] = requestParameters['specialtyCodes'];
        }
        if (requestParameters['licenseTypes'] != null) {
            queryParameters['licenseTypes'] = requestParameters['licenseTypes'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfOrientationOpportunityDtoFromJSON)(jsonValue));
    }
    /**
     * List orientation opportunities for a facility (admins may omit facilityId to list across facilities)
     */
    async orientationOpportunityControllerListOrientationOpportunities(requestParameters = {}, initOverrides) {
        const response = await this.orientationOpportunityControllerListOrientationOpportunitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get counts of orientation opportunities by status (active, archived) for tab badges
     */
    async orientationOpportunityControllerListOrientationOpportunityCountsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/counts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationOpportunityListCountsDtoFromJSON)(jsonValue));
    }
    /**
     * Get counts of orientation opportunities by status (active, archived) for tab badges
     */
    async orientationOpportunityControllerListOrientationOpportunityCounts(requestParameters = {}, initOverrides) {
        const response = await this.orientationOpportunityControllerListOrientationOpportunityCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List, per nurse profile, every time the nurse viewed the orientation opportunity (most recent first)
     */
    async orientationOpportunityControllerListOrientationOpportunityViewsRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerListOrientationOpportunityViews().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/views`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.OrientationOpportunityViewsByProfileDtoFromJSON));
    }
    /**
     * List, per nurse profile, every time the nurse viewed the orientation opportunity (most recent first)
     */
    async orientationOpportunityControllerListOrientationOpportunityViews(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerListOrientationOpportunityViewsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Message a single matched nurse about an orientation opportunity by email and SMS, with a personal message
     */
    async orientationOpportunityControllerNotifyOrientationOpportunityMatchRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerNotifyOrientationOpportunityMatch().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerNotifyOrientationOpportunityMatch().');
        }
        if (requestParameters['orientationOpportunityNotifyDto'] == null) {
            throw new runtime.RequiredError('orientationOpportunityNotifyDto', 'Required parameter "orientationOpportunityNotifyDto" was null or undefined when calling orientationOpportunityControllerNotifyOrientationOpportunityMatch().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/nurse/{profileId}/notify`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationOpportunityNotifyDtoToJSON)(requestParameters['orientationOpportunityNotifyDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Message a single matched nurse about an orientation opportunity by email and SMS, with a personal message
     */
    async orientationOpportunityControllerNotifyOrientationOpportunityMatch(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerNotifyOrientationOpportunityMatchRaw(requestParameters, initOverrides);
    }
    /**
     * Notify all eligible matched nurses (or a given subset) about an orientation opportunity by email and SMS
     */
    async orientationOpportunityControllerNotifyOrientationOpportunityMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerNotifyOrientationOpportunityMatches().');
        }
        const queryParameters = {};
        if (requestParameters['profileIds'] != null) {
            queryParameters['profileIds'] = requestParameters['profileIds'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/notify`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Notify all eligible matched nurses (or a given subset) about an orientation opportunity by email and SMS
     */
    async orientationOpportunityControllerNotifyOrientationOpportunityMatches(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerNotifyOrientationOpportunityMatchesRaw(requestParameters, initOverrides);
    }
    /**
     * Submit a nurse request expressing interest in an orientation opportunity, with a required message
     */
    async orientationOpportunityControllerRequestOrientationOpportunityRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerRequestOrientationOpportunity().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerRequestOrientationOpportunity().');
        }
        if (requestParameters['orientationOpportunityRequestDto'] == null) {
            throw new runtime.RequiredError('orientationOpportunityRequestDto', 'Required parameter "orientationOpportunityRequestDto" was null or undefined when calling orientationOpportunityControllerRequestOrientationOpportunity().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/nurse/{profileId}/request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationOpportunityRequestDtoToJSON)(requestParameters['orientationOpportunityRequestDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit a nurse request expressing interest in an orientation opportunity, with a required message
     */
    async orientationOpportunityControllerRequestOrientationOpportunity(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerRequestOrientationOpportunityRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an orientation opportunity\'s sessions, rates, specialty, description, or stipends as a facility member
     */
    async orientationOpportunityControllerUpdateOrientationOpportunityRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerUpdateOrientationOpportunity().');
        }
        if (requestParameters['orientationOpportunityUpdateDto'] == null) {
            throw new runtime.RequiredError('orientationOpportunityUpdateDto', 'Required parameter "orientationOpportunityUpdateDto" was null or undefined when calling orientationOpportunityControllerUpdateOrientationOpportunity().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationOpportunityUpdateDtoToJSON)(requestParameters['orientationOpportunityUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationOpportunityDtoFromJSON)(jsonValue));
    }
    /**
     * Edit an orientation opportunity\'s sessions, rates, specialty, description, or stipends as a facility member
     */
    async orientationOpportunityControllerUpdateOrientationOpportunity(requestParameters, initOverrides) {
        const response = await this.orientationOpportunityControllerUpdateOrientationOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload orientation documents (PNG, JPEG, PDF) for a nurse scheduled on an orientation opportunity
     */
    async orientationOpportunityControllerUploadOrientationOpportunityDocumentsRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerUploadOrientationOpportunityDocuments().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerUploadOrientationOpportunityDocuments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['documents'] != null) {
            requestParameters['documents'].forEach((element) => {
                formParams.append('documents', element);
            });
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/document/{profileId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload orientation documents (PNG, JPEG, PDF) for a nurse scheduled on an orientation opportunity
     */
    async orientationOpportunityControllerUploadOrientationOpportunityDocuments(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerUploadOrientationOpportunityDocumentsRaw(requestParameters, initOverrides);
    }
    /**
     * Withdraw a pending nurse request for an orientation opportunity
     */
    async orientationOpportunityControllerWithdrawOrientationOpportunityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling orientationOpportunityControllerWithdrawOrientationOpportunityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling orientationOpportunityControllerWithdrawOrientationOpportunityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orientation-opportunity/{id}/nurse/{profileId}/request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Withdraw a pending nurse request for an orientation opportunity
     */
    async orientationOpportunityControllerWithdrawOrientationOpportunityRequest(requestParameters, initOverrides) {
        await this.orientationOpportunityControllerWithdrawOrientationOpportunityRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Calculate and upsert bi-weekly pay period boundaries for a shift based on facility timezone
     */
    async payPeriodControllerCreatePayPeriodRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling payPeriodControllerCreatePayPeriod().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-periods/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Calculate and upsert bi-weekly pay period boundaries for a shift based on facility timezone
     */
    async payPeriodControllerCreatePayPeriod(requestParameters, initOverrides) {
        await this.payPeriodControllerCreatePayPeriodRaw(requestParameters, initOverrides);
    }
    /**
     * List all distinct pay period date ranges across all shifts, sorted by most recent
     */
    async payPeriodControllerGetAllPayPeriodsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-periods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayPeriodAbbrDtoFromJSON));
    }
    /**
     * List all distinct pay period date ranges across all shifts, sorted by most recent
     */
    async payPeriodControllerGetAllPayPeriods(initOverrides) {
        const response = await this.payPeriodControllerGetAllPayPeriodsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Approve a Zeal employee check for payroll processing and disbursement
     */
    async payrollControllerApproveEmployeeCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['zealEmployeeCheckId'] == null) {
            throw new runtime.RequiredError('zealEmployeeCheckId', 'Required parameter "zealEmployeeCheckId" was null or undefined when calling payrollControllerApproveEmployeeCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/employee-checks/{zealEmployeeCheckId}/approve`.replace(`{${"zealEmployeeCheckId"}}`, encodeURIComponent(String(requestParameters['zealEmployeeCheckId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     * Approve a Zeal employee check for payroll processing and disbursement
     */
    async payrollControllerApproveEmployeeCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerApproveEmployeeCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a single Zeal payroll check with auto-sync if data is stale (>15 min)
     */
    async payrollControllerGetCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError('checkId', 'Required parameter "checkId" was null or undefined when calling payrollControllerGetCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/checks/{checkId}`.replace(`{${"checkId"}}`, encodeURIComponent(String(requestParameters['checkId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     * Get a single Zeal payroll check with auto-sync if data is stale (>15 min)
     */
    async payrollControllerGetCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a Zeal-hosted I-9 employment eligibility verification link for a nurse
     */
    async payrollControllerGetI9LinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetI9Link().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/i9-link`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     * Get a Zeal-hosted I-9 employment eligibility verification link for a nurse
     */
    async payrollControllerGetI9Link(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetI9LinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get or initiate Zeal onboarding and return the employee dashboard or onboarding link
     */
    async payrollControllerGetLinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetLink().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/link`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     * Get or initiate Zeal onboarding and return the employee dashboard or onboarding link
     */
    async payrollControllerGetLink(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Fetch the result of a Zeal overtime preview job, with per-nurse expected overtime once complete
     */
    async payrollControllerGetOvertimePreviewRaw(requestParameters, initOverrides) {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError('jobId', 'Required parameter "jobId" was null or undefined when calling payrollControllerGetOvertimePreview().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/overtime-preview/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OvertimePreviewResultDtoFromJSON)(jsonValue));
    }
    /**
     * Fetch the result of a Zeal overtime preview job, with per-nurse expected overtime once complete
     */
    async payrollControllerGetOvertimePreview(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetOvertimePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List Zeal employee payroll checks with filtering by approval, status, pay period, and nurse name
     */
    async payrollControllerGetPaychecksRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['isApproved'] != null) {
            queryParameters['isApproved'] = requestParameters['isApproved'];
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['payPeriodStart'] != null) {
            queryParameters['payPeriodStart'] = requestParameters['payPeriodStart'].toISOString();
        }
        if (requestParameters['payPeriodEnd'] != null) {
            queryParameters['payPeriodEnd'] = requestParameters['payPeriodEnd'].toISOString();
        }
        if (requestParameters['forceSync'] != null) {
            queryParameters['forceSync'] = requestParameters['forceSync'];
        }
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/employee-checks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayrollEmployeeCheckDtoFromJSON));
    }
    /**
     * List Zeal employee payroll checks with filtering by approval, status, pay period, and nurse name
     */
    async payrollControllerGetPaychecks(requestParameters = {}, initOverrides) {
        const response = await this.payrollControllerGetPaychecksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a Zeal-hosted paystub PDF download link for a specific payroll check
     */
    async payrollControllerGetPaystubLinkRaw(requestParameters, initOverrides) {
        if (requestParameters['checkId'] == null) {
            throw new runtime.RequiredError('checkId', 'Required parameter "checkId" was null or undefined when calling payrollControllerGetPaystubLink().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/checks/{checkId}/paystub-link`.replace(`{${"checkId"}}`, encodeURIComponent(String(requestParameters['checkId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     * Get a Zeal-hosted paystub PDF download link for a specific payroll check
     */
    async payrollControllerGetPaystubLink(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetPaystubLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Zeal payroll employee profile and onboarding status for a nurse
     */
    async payrollControllerGetProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/profile`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Get Zeal payroll employee profile and onboarding status for a nurse
     */
    async payrollControllerGetProfile(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a Zeal-hosted W-2 tax document download link for the previous tax year
     */
    async payrollControllerGetW2LinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetW2Link().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/w2-link`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     * Get a Zeal-hosted W-2 tax document download link for the previous tax year
     */
    async payrollControllerGetW2Link(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetW2LinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List state jurisdictions where a nurse has submitted W-4 tax paperwork in Zeal
     */
    async payrollControllerGetW4JurisdictionsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetW4Jurisdictions().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/w4-jurisdictions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List state jurisdictions where a nurse has submitted W-4 tax paperwork in Zeal
     */
    async payrollControllerGetW4Jurisdictions(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetW4JurisdictionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a Zeal-hosted W-4 tax withholding form link for a specific jurisdiction
     */
    async payrollControllerGetW4LinkRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerGetW4Link().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        if (requestParameters['jurisdiction'] != null) {
            queryParameters['jurisdiction'] = requestParameters['jurisdiction'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/w4-link`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollLinkDtoFromJSON)(jsonValue));
    }
    /**
     * Get a Zeal-hosted W-4 tax withholding form link for a specific jurisdiction
     */
    async payrollControllerGetW4Link(requestParameters, initOverrides) {
        const response = await this.payrollControllerGetW4LinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Zeal paycheck history for a nurse, including earnings, taxes, and disbursement status
     */
    async payrollControllerHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerHistory().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/history`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayrollEmployeeCheckDtoFromJSON));
    }
    /**
     * Get Zeal paycheck history for a nurse, including earnings, taxes, and disbursement status
     */
    async payrollControllerHistory(requestParameters, initOverrides) {
        const response = await this.payrollControllerHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List active shifts with assigned nurses for payroll processing within a pay period date range
     */
    async payrollControllerListPayrollShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['after'] == null) {
            throw new runtime.RequiredError('after', 'Required parameter "after" was null or undefined when calling payrollControllerListPayrollShifts().');
        }
        if (requestParameters['before'] == null) {
            throw new runtime.RequiredError('before', 'Required parameter "before" was null or undefined when calling payrollControllerListPayrollShifts().');
        }
        const queryParameters = {};
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'].toISOString();
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'].toISOString();
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/shifts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PayrollShiftListItemDtoFromJSON));
    }
    /**
     * List active shifts with assigned nurses for payroll processing within a pay period date range
     */
    async payrollControllerListPayrollShifts(requestParameters, initOverrides) {
        const response = await this.payrollControllerListPayrollShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete and re-create the Zeal employee record to restart payroll onboarding from scratch
     */
    async payrollControllerResetOnboardingRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerResetOnboarding().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/reset`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete and re-create the Zeal employee record to restart payroll onboarding from scratch
     */
    async payrollControllerResetOnboarding(requestParameters, initOverrides) {
        await this.payrollControllerResetOnboardingRaw(requestParameters, initOverrides);
    }
    /**
     * Resync Zeal checks for a shift, unlinking pay periods whose checks no longer exist or no longer reference this shift
     */
    async payrollControllerResyncShiftZealChecksRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling payrollControllerResyncShiftZealChecks().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/shifts/{shiftId}/resync-zeal-checks`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Resync Zeal checks for a shift, unlinking pay periods whose checks no longer exist or no longer reference this shift
     */
    async payrollControllerResyncShiftZealChecks(requestParameters, initOverrides) {
        const response = await this.payrollControllerResyncShiftZealChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Associate a Zeal employee check ID with an internal pay period record and sync check data
     */
    async payrollControllerSetPayPeriodZealCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['payPeriodId'] == null) {
            throw new runtime.RequiredError('payPeriodId', 'Required parameter "payPeriodId" was null or undefined when calling payrollControllerSetPayPeriodZealCheck().');
        }
        if (requestParameters['setZealCheckDto'] == null) {
            throw new runtime.RequiredError('setZealCheckDto', 'Required parameter "setZealCheckDto" was null or undefined when calling payrollControllerSetPayPeriodZealCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/pay-periods/{payPeriodId}/zeal-check`.replace(`{${"payPeriodId"}}`, encodeURIComponent(String(requestParameters['payPeriodId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SetZealCheckDtoToJSON)(requestParameters['setZealCheckDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     * Associate a Zeal employee check ID with an internal pay period record and sync check data
     */
    async payrollControllerSetPayPeriodZealCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerSetPayPeriodZealCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start a Zeal overtime preview of the pay period\'s pending employee checks
     */
    async payrollControllerStartOvertimePreviewRaw(requestParameters, initOverrides) {
        if (requestParameters['startOvertimePreviewDto'] == null) {
            throw new runtime.RequiredError('startOvertimePreviewDto', 'Required parameter "startOvertimePreviewDto" was null or undefined when calling payrollControllerStartOvertimePreview().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/overtime-preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.StartOvertimePreviewDtoToJSON)(requestParameters['startOvertimePreviewDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OvertimePreviewStartDtoFromJSON)(jsonValue));
    }
    /**
     * Start a Zeal overtime preview of the pay period\'s pending employee checks
     */
    async payrollControllerStartOvertimePreview(requestParameters, initOverrides) {
        const response = await this.payrollControllerStartOvertimePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async payrollControllerSyncI9StatusRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling payrollControllerSyncI9Status().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/{profileId}/sync-i9`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollProfileDtoFromJSON)(jsonValue));
    }
    /**
     */
    async payrollControllerSyncI9Status(requestParameters, initOverrides) {
        const response = await this.payrollControllerSyncI9StatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Revoke approval on a Zeal employee check to prevent it from being processed
     */
    async payrollControllerUnapproveEmployeeCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['zealEmployeeCheckId'] == null) {
            throw new runtime.RequiredError('zealEmployeeCheckId', 'Required parameter "zealEmployeeCheckId" was null or undefined when calling payrollControllerUnapproveEmployeeCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payroll/employee-checks/{zealEmployeeCheckId}/approve`.replace(`{${"zealEmployeeCheckId"}}`, encodeURIComponent(String(requestParameters['zealEmployeeCheckId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PayrollEmployeeCheckDtoFromJSON)(jsonValue));
    }
    /**
     * Revoke approval on a Zeal employee check to prevent it from being processed
     */
    async payrollControllerUnapproveEmployeeCheck(requestParameters, initOverrides) {
        const response = await this.payrollControllerUnapproveEmployeeCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Process Zeal webhook when a nurse completes payroll onboarding and employee setup
     */
    async payrollOnboardingControllerHandlePayrollOnboardingWebhookRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/payroll/webhook/onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Zeal webhook when a nurse completes payroll onboarding and employee setup
     */
    async payrollOnboardingControllerHandlePayrollOnboardingWebhook(initOverrides) {
        await this.payrollOnboardingControllerHandlePayrollOnboardingWebhookRaw(initOverrides);
    }
    /**
     * External health check endpoint used by UptimeRobot monitoring
     */
    async pingControllerGetPingRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/ping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * External health check endpoint used by UptimeRobot monitoring
     */
    async pingControllerGetPing(initOverrides) {
        await this.pingControllerGetPingRaw(initOverrides);
    }
    /**
     * List all Auth0 users with platform administrator roles
     */
    async platformAdminControllerGetPlatformAdminsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/platform-admin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PlatformAdminDtoFromJSON));
    }
    /**
     * List all Auth0 users with platform administrator roles
     */
    async platformAdminControllerGetPlatformAdmins(initOverrides) {
        const response = await this.platformAdminControllerGetPlatformAdminsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Add a new address and geocode it for travel distance calculations
     */
    async profileControllerCreateProfileAddressRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerCreateProfileAddress().');
        }
        if (requestParameters['addressCreateDto'] == null) {
            throw new runtime.RequiredError('addressCreateDto', 'Required parameter "addressCreateDto" was null or undefined when calling profileControllerCreateProfileAddress().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AddressCreateDtoToJSON)(requestParameters['addressCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AddressDtoFromJSON)(jsonValue));
    }
    /**
     * Add a new address and geocode it for travel distance calculations
     */
    async profileControllerCreateProfileAddress(requestParameters, initOverrides) {
        const response = await this.profileControllerCreateProfileAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add a validated US phone number with optional SMS opt-in
     */
    async profileControllerCreateProfilePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerCreateProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberCreateDto'] == null) {
            throw new runtime.RequiredError('phoneNumberCreateDto', 'Required parameter "phoneNumberCreateDto" was null or undefined when calling profileControllerCreateProfilePhoneNumber().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.PhoneNumberCreateDtoToJSON)(requestParameters['phoneNumberCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PhoneNumberDtoFromJSON)(jsonValue));
    }
    /**
     * Add a validated US phone number with optional SMS opt-in
     */
    async profileControllerCreateProfilePhoneNumber(requestParameters, initOverrides) {
        const response = await this.profileControllerCreateProfilePhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove a saved address from a user profile
     */
    async profileControllerDeleteProfileAddressRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerDeleteProfileAddress().');
        }
        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError('addressId', 'Required parameter "addressId" was null or undefined when calling profileControllerDeleteProfileAddress().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address/{addressId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"addressId"}}`, encodeURIComponent(String(requestParameters['addressId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a saved address from a user profile
     */
    async profileControllerDeleteProfileAddress(requestParameters, initOverrides) {
        await this.profileControllerDeleteProfileAddressRaw(requestParameters, initOverrides);
    }
    /**
     * Remove a phone number from a user profile
     */
    async profileControllerDeleteProfilePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerDeleteProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberId'] == null) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter "phoneNumberId" was null or undefined when calling profileControllerDeleteProfilePhoneNumber().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber/{phoneNumberId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters['phoneNumberId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a phone number from a user profile
     */
    async profileControllerDeleteProfilePhoneNumber(requestParameters, initOverrides) {
        await this.profileControllerDeleteProfilePhoneNumberRaw(requestParameters, initOverrides);
    }
    /**
     * Get the S3 profile photo URL for a user
     */
    async profileControllerGetAvatarRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetAvatar().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/avatar`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AvatarDtoFromJSON)(jsonValue));
    }
    /**
     * Get the S3 profile photo URL for a user
     */
    async profileControllerGetAvatar(requestParameters, initOverrides) {
        const response = await this.profileControllerGetAvatarRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get name, avatar, and verified facility list for a user (lightweight)
     */
    async profileControllerGetBasicProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetBasicProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/basic`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.BasicProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Get name, avatar, and verified facility list for a user (lightweight)
     */
    async profileControllerGetBasicProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerGetBasicProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the profile photo URL for the logged-in user
     */
    async profileControllerGetCurrentUserAvatarRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/me/avatar`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AvatarDtoFromJSON)(jsonValue));
    }
    /**
     * Get the profile photo URL for the logged-in user
     */
    async profileControllerGetCurrentUserAvatar(initOverrides) {
        const response = await this.profileControllerGetCurrentUserAvatarRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get full profile for the logged-in user including addresses, roles, payroll status, and verified facilities
     */
    async profileControllerGetCurrentUserProfileRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Get full profile for the logged-in user including addresses, roles, payroll status, and verified facilities
     */
    async profileControllerGetCurrentUserProfile(initOverrides) {
        const response = await this.profileControllerGetCurrentUserProfileRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get Auth0 roles (e.g. nurse, facility admin) for the logged-in user
     */
    async profileControllerGetCurrentUserRolesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/me/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RolesDtoFromJSON)(jsonValue));
    }
    /**
     * Get Auth0 roles (e.g. nurse, facility admin) for the logged-in user
     */
    async profileControllerGetCurrentUserRoles(initOverrides) {
        const response = await this.profileControllerGetCurrentUserRolesRaw(initOverrides);
        return await response.value();
    }
    /**
     * List active facilities where the user is a staff member
     */
    async profileControllerGetMemberFacilitiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetMemberFacilities().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/facilities`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityDtoFromJSON));
    }
    /**
     * List active facilities where the user is a staff member
     */
    async profileControllerGetMemberFacilities(requestParameters, initOverrides) {
        const response = await this.profileControllerGetMemberFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get full profile with addresses, roles, specialties, payroll status, and verified facilities
     */
    async profileControllerGetProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Get full profile with addresses, roles, specialties, payroll status, and verified facilities
     */
    async profileControllerGetProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all saved addresses (home, mailing, etc.) for a user
     */
    async profileControllerGetProfileAddressesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfileAddresses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.AddressDtoFromJSON));
    }
    /**
     * List all saved addresses (home, mailing, etc.) for a user
     */
    async profileControllerGetProfileAddresses(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List phone numbers with type and SMS opt-in status for a user
     */
    async profileControllerGetProfilePhoneNumbersRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfilePhoneNumbers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.PhoneNumberDtoFromJSON));
    }
    /**
     * List phone numbers with type and SMS opt-in status for a user
     */
    async profileControllerGetProfilePhoneNumbers(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfilePhoneNumbersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get nurse shift preferences including max travel distance, minimum pay rate, and preferred shift times
     */
    async profileControllerGetProfileShiftPreferencesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfileShiftPreferences().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/preference/shifts`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftPreferencesDtoFromJSON)(jsonValue));
    }
    /**
     * Get nurse shift preferences including max travel distance, minimum pay rate, and preferred shift times
     */
    async profileControllerGetProfileShiftPreferences(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileShiftPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List facilities with nurse verification status and orientation document completion, excluding blocked facilities
     */
    async profileControllerGetProfileVerifiedFacilitiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetProfileVerifiedFacilities().');
        }
        const queryParameters = {};
        if (requestParameters['includeAllFacilities'] != null) {
            queryParameters['includeAllFacilities'] = requestParameters['includeAllFacilities'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/verified-facilities`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityVerificationDtoFromJSON));
    }
    /**
     * List facilities with nurse verification status and orientation document completion, excluding blocked facilities
     */
    async profileControllerGetProfileVerifiedFacilities(requestParameters, initOverrides) {
        const response = await this.profileControllerGetProfileVerifiedFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a one-time download URL for a nurse avatar with Content-Disposition: attachment
     */
    async profileControllerGetPublicAvatarDownloadUrlRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetPublicAvatarDownloadUrl().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/public/avatar-download-url`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AvatarDtoFromJSON)(jsonValue));
    }
    /**
     * Get a one-time download URL for a nurse avatar with Content-Disposition: attachment
     */
    async profileControllerGetPublicAvatarDownloadUrl(requestParameters, initOverrides) {
        const response = await this.profileControllerGetPublicAvatarDownloadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get nurse profile visible to facility admins, including credentials, specialties, shift history, and background checks
     */
    async profileControllerGetPublicProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetPublicProfile().');
        }
        const queryParameters = {};
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/public`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PublicProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Get nurse profile visible to facility admins, including credentials, specialties, shift history, and background checks
     */
    async profileControllerGetPublicProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerGetPublicProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Download the uploaded resume PDF for a nurse
     */
    async profileControllerGetResumeRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetResume().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/resume`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FileDtoFromJSON)(jsonValue));
    }
    /**
     * Download the uploaded resume PDF for a nurse
     */
    async profileControllerGetResume(requestParameters, initOverrides) {
        const response = await this.profileControllerGetResumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Auth0 permission scopes granted to a user
     */
    async profileControllerGetUserPermissionsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetUserPermissions().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/permissions`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PermissionsDtoFromJSON)(jsonValue));
    }
    /**
     * Get Auth0 permission scopes granted to a user
     */
    async profileControllerGetUserPermissions(requestParameters, initOverrides) {
        const response = await this.profileControllerGetUserPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Auth0 roles (e.g. nurse, facility admin) assigned to a user
     */
    async profileControllerGetUserRolesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerGetUserRoles().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/roles`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RolesDtoFromJSON)(jsonValue));
    }
    /**
     * Get Auth0 roles (e.g. nurse, facility admin) assigned to a user
     */
    async profileControllerGetUserRoles(requestParameters, initOverrides) {
        const response = await this.profileControllerGetUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Search nurse/user profiles — the preferred way to look up a profile by name or email (via the `search` param), which for platform admins also matches text in the profile\'s internal admin notes, and to filter by role, specialty (optionally constrained by per-specialty assessment/certification status), location (`homeState`, `licenseJurisdictions`, `authorizedStates`), license verification status (`licenseStatus`), credential status, background check status, or facility membership. `regulatoryAssessmentsCompletedAfter`/`Before` find the nurses who finished a round of regulatory assessments in a date range — the way to answer \"who completed their regulatory assessments last week\". The response includes each nurse\'s specialties with their assessment and certification status.
     */
    async profileControllerListProfilesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['filterMode'] != null) {
            queryParameters['filterMode'] = requestParameters['filterMode'];
        }
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['dhsBackgroundCheckStatus'] != null) {
            queryParameters['dhsBackgroundCheckStatus'] = requestParameters['dhsBackgroundCheckStatus'];
        }
        if (requestParameters['certificationVerificationStatus'] != null) {
            queryParameters['certificationVerificationStatus'] = requestParameters['certificationVerificationStatus'];
        }
        if (requestParameters['hasExpiredCertification'] != null) {
            queryParameters['hasExpiredCertification'] = requestParameters['hasExpiredCertification'];
        }
        if (requestParameters['hasExpiredLicense'] != null) {
            queryParameters['hasExpiredLicense'] = requestParameters['hasExpiredLicense'];
        }
        if (requestParameters['hasExhaustedAssessment'] != null) {
            queryParameters['hasExhaustedAssessment'] = requestParameters['hasExhaustedAssessment'];
        }
        if (requestParameters['isReadyToWork'] != null) {
            queryParameters['isReadyToWork'] = requestParameters['isReadyToWork'];
        }
        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }
        if (requestParameters['specialtyAssessmentStatus'] != null) {
            queryParameters['specialtyAssessmentStatus'] = requestParameters['specialtyAssessmentStatus'];
        }
        if (requestParameters['specialtyCertificationStatus'] != null) {
            queryParameters['specialtyCertificationStatus'] = requestParameters['specialtyCertificationStatus'];
        }
        if (requestParameters['blockedAtFacilityId'] != null) {
            queryParameters['blockedAtFacilityId'] = requestParameters['blockedAtFacilityId'];
        }
        if (requestParameters['licenseStatus'] != null) {
            queryParameters['licenseStatus'] = requestParameters['licenseStatus'];
        }
        if (requestParameters['minFacilityBlockCount'] != null) {
            queryParameters['minFacilityBlockCount'] = requestParameters['minFacilityBlockCount'];
        }
        if (requestParameters['licenseExpiringBefore'] != null) {
            queryParameters['licenseExpiringBefore'] = requestParameters['licenseExpiringBefore'];
        }
        if (requestParameters['homeState'] != null) {
            queryParameters['homeState'] = requestParameters['homeState'];
        }
        if (requestParameters['createdAfter'] != null) {
            queryParameters['createdAfter'] = requestParameters['createdAfter'];
        }
        if (requestParameters['createdBefore'] != null) {
            queryParameters['createdBefore'] = requestParameters['createdBefore'];
        }
        if (requestParameters['regulatoryAssessmentsCompletedAfter'] != null) {
            queryParameters['regulatoryAssessmentsCompletedAfter'] = requestParameters['regulatoryAssessmentsCompletedAfter'];
        }
        if (requestParameters['regulatoryAssessmentsCompletedBefore'] != null) {
            queryParameters['regulatoryAssessmentsCompletedBefore'] = requestParameters['regulatoryAssessmentsCompletedBefore'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['authorizedStates'] != null) {
            queryParameters['authorizedStates'] = requestParameters['authorizedStates'];
        }
        if (requestParameters['licenseJurisdictions'] != null) {
            queryParameters['licenseJurisdictions'] = requestParameters['licenseJurisdictions'];
        }
        if (requestParameters['emrSystems'] != null) {
            queryParameters['emrSystems'] = requestParameters['emrSystems'];
        }
        if (requestParameters['vaccinationTypes'] != null) {
            queryParameters['vaccinationTypes'] = requestParameters['vaccinationTypes'];
        }
        if (requestParameters['backgroundCheckStatuses'] != null) {
            queryParameters['backgroundCheckStatuses'] = requestParameters['backgroundCheckStatuses'];
        }
        if (requestParameters['certificationTypes'] != null) {
            queryParameters['certificationTypes'] = requestParameters['certificationTypes'];
        }
        if (requestParameters['specialtyCodes'] != null) {
            queryParameters['specialtyCodes'] = requestParameters['specialtyCodes'];
        }
        if (requestParameters['incompleteSections'] != null) {
            queryParameters['incompleteSections'] = requestParameters['incompleteSections'];
        }
        if (requestParameters['completedSections'] != null) {
            queryParameters['completedSections'] = requestParameters['completedSections'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfListProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Search nurse/user profiles — the preferred way to look up a profile by name or email (via the `search` param), which for platform admins also matches text in the profile\'s internal admin notes, and to filter by role, specialty (optionally constrained by per-specialty assessment/certification status), location (`homeState`, `licenseJurisdictions`, `authorizedStates`), license verification status (`licenseStatus`), credential status, background check status, or facility membership. `regulatoryAssessmentsCompletedAfter`/`Before` find the nurses who finished a round of regulatory assessments in a date range — the way to answer \"who completed their regulatory assessments last week\". The response includes each nurse\'s specialties with their assessment and certification status.
     */
    async profileControllerListProfiles(requestParameters = {}, initOverrides) {
        const response = await this.profileControllerListProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Look up a profile by phone number
     */
    async profileControllerLookupProfileByPhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError('phoneNumber', 'Required parameter "phoneNumber" was null or undefined when calling profileControllerLookupProfileByPhoneNumber().');
        }
        const queryParameters = {};
        if (requestParameters['phoneNumber'] != null) {
            queryParameters['phoneNumber'] = requestParameters['phoneNumber'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/lookup/by-phone-number`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PhoneNumberLookupDtoFromJSON)(jsonValue));
    }
    /**
     * Look up a profile by phone number
     */
    async profileControllerLookupProfileByPhoneNumber(requestParameters, initOverrides) {
        const response = await this.profileControllerLookupProfileByPhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update personal info (name, DOB, SSN, address, phone) with SSN uniqueness validation
     */
    async profileControllerUpdateProfileRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfile().');
        }
        if (requestParameters['profileUpdateDto'] == null) {
            throw new runtime.RequiredError('profileUpdateDto', 'Required parameter "profileUpdateDto" was null or undefined when calling profileControllerUpdateProfile().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfileUpdateDtoToJSON)(requestParameters['profileUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ProfileDtoFromJSON)(jsonValue));
    }
    /**
     * Update personal info (name, DOB, SSN, address, phone) with SSN uniqueness validation
     */
    async profileControllerUpdateProfile(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update an address and re-geocode it for travel distance calculations
     */
    async profileControllerUpdateProfileAddressRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfileAddress().');
        }
        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError('addressId', 'Required parameter "addressId" was null or undefined when calling profileControllerUpdateProfileAddress().');
        }
        if (requestParameters['addressUpdateDto'] == null) {
            throw new runtime.RequiredError('addressUpdateDto', 'Required parameter "addressUpdateDto" was null or undefined when calling profileControllerUpdateProfileAddress().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/address/{addressId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"addressId"}}`, encodeURIComponent(String(requestParameters['addressId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.AddressUpdateDtoToJSON)(requestParameters['addressUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AddressDtoFromJSON)(jsonValue));
    }
    /**
     * Update an address and re-geocode it for travel distance calculations
     */
    async profileControllerUpdateProfileAddress(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfileAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a phone number with US validation and SMS opt-in/opt-out handling
     */
    async profileControllerUpdateProfilePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberId'] == null) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter "phoneNumberId" was null or undefined when calling profileControllerUpdateProfilePhoneNumber().');
        }
        if (requestParameters['phoneNumberUpdateDto'] == null) {
            throw new runtime.RequiredError('phoneNumberUpdateDto', 'Required parameter "phoneNumberUpdateDto" was null or undefined when calling profileControllerUpdateProfilePhoneNumber().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/phoneNumber/{phoneNumberId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters['phoneNumberId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.PhoneNumberUpdateDtoToJSON)(requestParameters['phoneNumberUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PhoneNumberDtoFromJSON)(jsonValue));
    }
    /**
     * Update a phone number with US validation and SMS opt-in/opt-out handling
     */
    async profileControllerUpdateProfilePhoneNumber(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfilePhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update the nurse bio/professional summary shown on their public profile
     */
    async profileControllerUpdateProfileProfessionalSummaryRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfileProfessionalSummary().');
        }
        if (requestParameters['professionalSummaryDto'] == null) {
            throw new runtime.RequiredError('professionalSummaryDto', 'Required parameter "professionalSummaryDto" was null or undefined when calling profileControllerUpdateProfileProfessionalSummary().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/professional-summary`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ProfessionalSummaryDtoToJSON)(requestParameters['professionalSummaryDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Create or update the nurse bio/professional summary shown on their public profile
     */
    async profileControllerUpdateProfileProfessionalSummary(requestParameters, initOverrides) {
        await this.profileControllerUpdateProfileProfessionalSummaryRaw(requestParameters, initOverrides);
    }
    /**
     * Set nurse shift preferences for max travel distance, minimum pay rate, and preferred shift times
     */
    async profileControllerUpdateProfileShiftPreferencesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUpdateProfileShiftPreferences().');
        }
        if (requestParameters['shiftPreferencesDto'] == null) {
            throw new runtime.RequiredError('shiftPreferencesDto', 'Required parameter "shiftPreferencesDto" was null or undefined when calling profileControllerUpdateProfileShiftPreferences().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/profile/{profileId}/preference/shifts`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftPreferencesDtoToJSON)(requestParameters['shiftPreferencesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftPreferencesDtoFromJSON)(jsonValue));
    }
    /**
     * Set nurse shift preferences for max travel distance, minimum pay rate, and preferred shift times
     */
    async profileControllerUpdateProfileShiftPreferences(requestParameters, initOverrides) {
        const response = await this.profileControllerUpdateProfileShiftPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload or replace a profile photo (PNG/JPEG) to S3
     */
    async profileControllerUploadProfilePhotoRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUploadProfilePhoto().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['profilePhoto'] != null) {
            formParams.append('profilePhoto', requestParameters['profilePhoto']);
        }
        const response = await this.request({
            path: `/profile/{profileId}/photo`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload or replace a profile photo (PNG/JPEG) to S3
     */
    async profileControllerUploadProfilePhoto(requestParameters, initOverrides) {
        await this.profileControllerUploadProfilePhotoRaw(requestParameters, initOverrides);
    }
    /**
     * Upload or replace a nurse resume (PDF) to S3
     */
    async profileControllerUploadResumeRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling profileControllerUploadResume().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['resume'] != null) {
            formParams.append('resume', requestParameters['resume']);
        }
        const response = await this.request({
            path: `/profile/{profileId}/resume`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload or replace a nurse resume (PDF) to S3
     */
    async profileControllerUploadResume(requestParameters, initOverrides) {
        await this.profileControllerUploadResumeRaw(requestParameters, initOverrides);
    }
    /**
     * Estimate nurse pay and facility bill rates based on location, experience, specialty, sector, and fee adjustments
     */
    async rateCalculatorControllerGetEstimatedRateRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        if (requestParameters['experience'] != null) {
            queryParameters['experience'] = requestParameters['experience'];
        }
        if (requestParameters['specialty'] != null) {
            queryParameters['specialty'] = requestParameters['specialty'];
        }
        if (requestParameters['sector'] != null) {
            queryParameters['sector'] = requestParameters['sector'];
        }
        if (requestParameters['adjustments'] != null) {
            queryParameters['adjustments'] = requestParameters['adjustments'];
        }
        if (requestParameters['employerTaxPercentage'] != null) {
            queryParameters['employerTaxPercentage'] = requestParameters['employerTaxPercentage'];
        }
        if (requestParameters['platformFeePercentage'] != null) {
            queryParameters['platformFeePercentage'] = requestParameters['platformFeePercentage'];
        }
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rate-calculator`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RateEstimateDtoFromJSON)(jsonValue));
    }
    /**
     * Estimate nurse pay and facility bill rates based on location, experience, specialty, sector, and fee adjustments
     */
    async rateCalculatorControllerGetEstimatedRate(requestParameters = {}, initOverrides) {
        const response = await this.rateCalculatorControllerGetEstimatedRateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get available locations, specialties, sectors, and adjustment options for the rate calculator
     */
    async rateCalculatorControllerGetOptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rate-calculator/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RateCalculatorOptionsDtoFromJSON)(jsonValue));
    }
    /**
     * Get available locations, specialties, sectors, and adjustment options for the rate calculator
     */
    async rateCalculatorControllerGetOptions(initOverrides) {
        const response = await this.rateCalculatorControllerGetOptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Create a new regulatory assessment configuration linked to a Relias assessment ID
     */
    async regulatoryAssessmentsControllerCreateRegulatoryAssessmentRaw(requestParameters, initOverrides) {
        if (requestParameters['regulatoryAssessmentAdminDto'] == null) {
            throw new runtime.RequiredError('regulatoryAssessmentAdminDto', 'Required parameter "regulatoryAssessmentAdminDto" was null or undefined when calling regulatoryAssessmentsControllerCreateRegulatoryAssessment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegulatoryAssessmentAdminDtoToJSON)(requestParameters['regulatoryAssessmentAdminDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminDtoFromJSON)(jsonValue));
    }
    /**
     * Create a new regulatory assessment configuration linked to a Relias assessment ID
     */
    async regulatoryAssessmentsControllerCreateRegulatoryAssessment(requestParameters, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerCreateRegulatoryAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a regulatory assessment configuration by its unique code
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessmentRaw(requestParameters, initOverrides) {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling regulatoryAssessmentsControllerGetRegulatoryAssessment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminDtoFromJSON)(jsonValue));
    }
    /**
     * Get a regulatory assessment configuration by its unique code
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessment(requestParameters, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerGetRegulatoryAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all Relias regulatory assessment configurations, optionally including inactive ones
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminListDtoFromJSON)(jsonValue));
    }
    /**
     * List all Relias regulatory assessment configurations, optionally including inactive ones
     */
    async regulatoryAssessmentsControllerGetRegulatoryAssessments(requestParameters = {}, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerGetRegulatoryAssessmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a regulatory assessment configuration (name, active status, Relias assessment link)
     */
    async regulatoryAssessmentsControllerUpdateRegulatoryAssessmentRaw(requestParameters, initOverrides) {
        if (requestParameters['regulatoryAssessmentAdminDto'] == null) {
            throw new runtime.RequiredError('regulatoryAssessmentAdminDto', 'Required parameter "regulatoryAssessmentAdminDto" was null or undefined when calling regulatoryAssessmentsControllerUpdateRegulatoryAssessment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/regulatory-assessments`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RegulatoryAssessmentAdminDtoToJSON)(requestParameters['regulatoryAssessmentAdminDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RegulatoryAssessmentAdminDtoFromJSON)(jsonValue));
    }
    /**
     * Update a regulatory assessment configuration (name, active status, Relias assessment link)
     */
    async regulatoryAssessmentsControllerUpdateRegulatoryAssessment(requestParameters, initOverrides) {
        const response = await this.regulatoryAssessmentsControllerUpdateRegulatoryAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Process Relias webhook when a nurse completes a competency assessment and update specialty/regulatory status
     */
    async reliasControllerAssignmentCompletedWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling reliasControllerAssignmentCompletedWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/relias/assignment-completed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Relias webhook when a nurse completes a competency assessment and update specialty/regulatory status
     */
    async reliasControllerAssignmentCompletedWebhook(requestParameters, initOverrides) {
        await this.reliasControllerAssignmentCompletedWebhookRaw(requestParameters, initOverrides);
    }
    /**
     * Get a nurse\'s available dates within a date range, optionally excluding dates with committed shifts
     */
    async scheduleControllerGetAvailabilityRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling scheduleControllerGetAvailability().');
        }
        const queryParameters = {};
        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'].toISOString();
        }
        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'].toISOString();
        }
        if (requestParameters['excludeCommittedDates'] != null) {
            queryParameters['excludeCommittedDates'] = requestParameters['excludeCommittedDates'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ScheduleAvailabilityDateDtoFromJSON));
    }
    /**
     * Get a nurse\'s available dates within a date range, optionally excluding dates with committed shifts
     */
    async scheduleControllerGetAvailability(requestParameters, initOverrides) {
        const response = await this.scheduleControllerGetAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a nurse\'s availability, their shifts at the given facility, and anonymized entries for their accepted shifts at any other facility
     */
    async scheduleControllerGetFacilityNurseScheduleRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling scheduleControllerGetFacilityNurseSchedule().');
        }
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError('facilityId', 'Required parameter "facilityId" was null or undefined when calling scheduleControllerGetFacilityNurseSchedule().');
        }
        const queryParameters = {};
        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'].toISOString();
        }
        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'].toISOString();
        }
        if (requestParameters['excludeCommittedDates'] != null) {
            queryParameters['excludeCommittedDates'] = requestParameters['excludeCommittedDates'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule/{nurseProfileId}/facility/{facilityId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))).replace(`{${"facilityId"}}`, encodeURIComponent(String(requestParameters['facilityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FacilityNurseScheduleDtoFromJSON)(jsonValue));
    }
    /**
     * Get a nurse\'s availability, their shifts at the given facility, and anonymized entries for their accepted shifts at any other facility
     */
    async scheduleControllerGetFacilityNurseSchedule(requestParameters, initOverrides) {
        const response = await this.scheduleControllerGetFacilityNurseScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Set the dates a nurse is available to work shifts
     */
    async scheduleControllerSetAvailabilityRaw(requestParameters, initOverrides) {
        if (requestParameters['nurseProfileId'] == null) {
            throw new runtime.RequiredError('nurseProfileId', 'Required parameter "nurseProfileId" was null or undefined when calling scheduleControllerSetAvailability().');
        }
        if (requestParameters['updateScheduleAvailabilityDto'] == null) {
            throw new runtime.RequiredError('updateScheduleAvailabilityDto', 'Required parameter "updateScheduleAvailabilityDto" was null or undefined when calling scheduleControllerSetAvailability().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule/{nurseProfileId}`.replace(`{${"nurseProfileId"}}`, encodeURIComponent(String(requestParameters['nurseProfileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.UpdateScheduleAvailabilityDtoToJSON)(requestParameters['updateScheduleAvailabilityDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Set the dates a nurse is available to work shifts
     */
    async scheduleControllerSetAvailability(requestParameters, initOverrides) {
        await this.scheduleControllerSetAvailabilityRaw(requestParameters, initOverrides);
    }
    /**
     * Browse active orientation opportunities the nurse matches, with cursor pagination
     */
    async searchControllerFindAvailableOrientationOpportunitiesRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationOpportunitySearchDto'] == null) {
            throw new runtime.RequiredError('orientationOpportunitySearchDto', 'Required parameter "orientationOpportunitySearchDto" was null or undefined when calling searchControllerFindAvailableOrientationOpportunities().');
        }
        const queryParameters = {};
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/orientation-opportunities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationOpportunitySearchDtoToJSON)(requestParameters['orientationOpportunitySearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSON)(jsonValue));
    }
    /**
     * Browse active orientation opportunities the nurse matches, with cursor pagination
     */
    async searchControllerFindAvailableOrientationOpportunities(requestParameters, initOverrides) {
        const response = await this.searchControllerFindAvailableOrientationOpportunitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Search unclaimed shifts by location, specialty, date, pay rate, and shift time with cursor pagination
     */
    async searchControllerFindAvailableShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftSearchDto'] == null) {
            throw new runtime.RequiredError('shiftSearchDto', 'Required parameter "shiftSearchDto" was null or undefined when calling searchControllerFindAvailableShifts().');
        }
        const queryParameters = {};
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/shifts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftSearchDtoToJSON)(requestParameters['shiftSearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfShiftSearchResultItemDtoFromJSON)(jsonValue));
    }
    /**
     * Search unclaimed shifts by location, specialty, date, pay rate, and shift time with cursor pagination
     */
    async searchControllerFindAvailableShifts(requestParameters, initOverrides) {
        const response = await this.searchControllerFindAvailableShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Find active facilities within a radius, with optional nurse verification filtering
     */
    async searchControllerFindFacilitiesWithinDistanceRaw(requestParameters, initOverrides) {
        if (requestParameters['facilitySearchDto'] == null) {
            throw new runtime.RequiredError('facilitySearchDto', 'Required parameter "facilitySearchDto" was null or undefined when calling searchControllerFindFacilitiesWithinDistance().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/facilities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.FacilitySearchDtoToJSON)(requestParameters['facilitySearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FacilityAbbrDtoFromJSON));
    }
    /**
     * Find active facilities within a radius, with optional nurse verification filtering
     */
    async searchControllerFindFacilitiesWithinDistance(requestParameters, initOverrides) {
        const response = await this.searchControllerFindFacilitiesWithinDistanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Count active orientation opportunities the nurse matches
     */
    async searchControllerGetAvailableOrientationOpportunitiesCountRaw(requestParameters, initOverrides) {
        if (requestParameters['orientationOpportunitySearchDto'] == null) {
            throw new runtime.RequiredError('orientationOpportunitySearchDto', 'Required parameter "orientationOpportunitySearchDto" was null or undefined when calling searchControllerGetAvailableOrientationOpportunitiesCount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/orientation-opportunities/count`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.OrientationOpportunitySearchDtoToJSON)(requestParameters['orientationOpportunitySearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.OrientationOpportunitySearchResultsCountDtoFromJSON)(jsonValue));
    }
    /**
     * Count active orientation opportunities the nurse matches
     */
    async searchControllerGetAvailableOrientationOpportunitiesCount(requestParameters, initOverrides) {
        const response = await this.searchControllerGetAvailableOrientationOpportunitiesCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Count available shifts matching search criteria, grouped by date
     */
    async searchControllerGetAvailableShiftsCountRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftSearchDto'] == null) {
            throw new runtime.RequiredError('shiftSearchDto', 'Required parameter "shiftSearchDto" was null or undefined when calling searchControllerGetAvailableShiftsCount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/search/shifts/count`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftSearchDtoToJSON)(requestParameters['shiftSearchDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftSearchResultsCountDtoFromJSON)(jsonValue));
    }
    /**
     * Count available shifts matching search criteria, grouped by date
     */
    async searchControllerGetAvailableShiftsCount(requestParameters, initOverrides) {
        const response = await this.searchControllerGetAvailableShiftsCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Accept a facility-initiated shift request and assign the nurse to the shift
     */
    async shiftControllerAcceptFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerAcceptFacilityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerAcceptFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/accept`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Accept a facility-initiated shift request and assign the nurse to the shift
     */
    async shiftControllerAcceptFacilityRequest(requestParameters, initOverrides) {
        await this.shiftControllerAcceptFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Approve a nurse-initiated shift request and assign the nurse to the shift
     */
    async shiftControllerApproveNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerApproveNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerApproveNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/approve`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Approve a nurse-initiated shift request and assign the nurse to the shift
     */
    async shiftControllerApproveNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerApproveNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Withdraw a pending facility-initiated shift request to a nurse
     */
    async shiftControllerCancelNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerCancelNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerCancelNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/request`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Withdraw a pending facility-initiated shift request to a nurse
     */
    async shiftControllerCancelNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerCancelNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Unassign a nurse from a confirmed shift and reopen it for new requests
     */
    async shiftControllerCancelShiftAssignmentRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerCancelShiftAssignment().');
        }
        if (requestParameters['nurseShiftCancellationCreateDto'] == null) {
            throw new runtime.RequiredError('nurseShiftCancellationCreateDto', 'Required parameter "nurseShiftCancellationCreateDto" was null or undefined when calling shiftControllerCancelShiftAssignment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/assignment`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.NurseShiftCancellationCreateDtoToJSON)(requestParameters['nurseShiftCancellationCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Unassign a nurse from a confirmed shift and reopen it for new requests
     */
    async shiftControllerCancelShiftAssignment(requestParameters, initOverrides) {
        await this.shiftControllerCancelShiftAssignmentRaw(requestParameters, initOverrides);
    }
    /**
     * Withdraw a pending nurse-initiated shift request before it is approved
     */
    async shiftControllerCancelShiftRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerCancelShiftRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerCancelShiftRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Withdraw a pending nurse-initiated shift request before it is approved
     */
    async shiftControllerCancelShiftRequest(requestParameters, initOverrides) {
        await this.shiftControllerCancelShiftRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Instantly claim an open/claimable shift and assign the nurse without facility approval
     */
    async shiftControllerClaimShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerClaimShift().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerClaimShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/claim`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Instantly claim an open/claimable shift and assign the nurse without facility approval
     */
    async shiftControllerClaimShift(requestParameters, initOverrides) {
        await this.shiftControllerClaimShiftRaw(requestParameters, initOverrides);
    }
    /**
     * Create a new shift posting at a facility with rate, specialty, and schedule details
     */
    async shiftControllerCreateShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftCreateDto'] == null) {
            throw new runtime.RequiredError('shiftCreateDto', 'Required parameter "shiftCreateDto" was null or undefined when calling shiftControllerCreateShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCreateDtoToJSON)(requestParameters['shiftCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     * Create a new shift posting at a facility with rate, specialty, and schedule details
     */
    async shiftControllerCreateShift(requestParameters, initOverrides) {
        const response = await this.shiftControllerCreateShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create multiple shift postings at a facility as a single all-or-nothing batch
     */
    async shiftControllerCreateShiftsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftBatchCreateDto'] == null) {
            throw new runtime.RequiredError('shiftBatchCreateDto', 'Required parameter "shiftBatchCreateDto" was null or undefined when calling shiftControllerCreateShifts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftBatchCreateDtoToJSON)(requestParameters['shiftBatchCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftDtoFromJSON));
    }
    /**
     * Create multiple shift postings at a facility as a single all-or-nothing batch
     */
    async shiftControllerCreateShifts(requestParameters, initOverrides) {
        const response = await this.shiftControllerCreateShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Decline a facility-initiated shift request as the invited nurse
     */
    async shiftControllerDeclineFacilityRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeclineFacilityRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerDeclineFacilityRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/decline`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Decline a facility-initiated shift request as the invited nurse
     */
    async shiftControllerDeclineFacilityRequest(requestParameters, initOverrides) {
        await this.shiftControllerDeclineFacilityRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Reject a nurse-initiated shift request as the facility owner
     */
    async shiftControllerDeclineNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeclineNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerDeclineNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/reject`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Reject a nurse-initiated shift request as the facility owner
     */
    async shiftControllerDeclineNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerDeclineNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Cancel a shift (with reason) or permanently hard-delete it from the system
     */
    async shiftControllerDeleteShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeleteShift().');
        }
        if (requestParameters['shiftCancellationDto'] == null) {
            throw new runtime.RequiredError('shiftCancellationDto', 'Required parameter "shiftCancellationDto" was null or undefined when calling shiftControllerDeleteShift().');
        }
        const queryParameters = {};
        if (requestParameters['hardDelete'] != null) {
            queryParameters['hardDelete'] = requestParameters['hardDelete'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCancellationDtoToJSON)(requestParameters['shiftCancellationDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancel a shift (with reason) or permanently hard-delete it from the system
     */
    async shiftControllerDeleteShift(requestParameters, initOverrides) {
        await this.shiftControllerDeleteShiftRaw(requestParameters, initOverrides);
    }
    /**
     * Remove all submitted clock-in/clock-out time entries and reset hours for a shift
     */
    async shiftControllerDeleteTimeWorkedRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDeleteTimeWorked().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/time-worked`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove all submitted clock-in/clock-out time entries and reset hours for a shift
     */
    async shiftControllerDeleteTimeWorked(requestParameters, initOverrides) {
        await this.shiftControllerDeleteTimeWorkedRaw(requestParameters, initOverrides);
    }
    /**
     * Dismiss a declined facility-to-nurse request to remove it from the shift request list
     */
    async shiftControllerDismissDeclinedNurseRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerDismissDeclinedNurseRequest().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerDismissDeclinedNurseRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/dismiss`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Dismiss a declined facility-to-nurse request to remove it from the shift request list
     */
    async shiftControllerDismissDeclinedNurseRequest(requestParameters, initOverrides) {
        await this.shiftControllerDismissDeclinedNurseRequestRaw(requestParameters, initOverrides);
    }
    /**
     * List shifts for admin overview or a nurse portfolio, with date/status/specialty filters
     */
    async shiftControllerListShiftsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['shiftDate'] != null) {
            queryParameters['shiftDate'] = requestParameters['shiftDate'].toISOString();
        }
        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'].toISOString();
        }
        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'].toISOString();
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['shiftType'] != null) {
            queryParameters['shiftType'] = requestParameters['shiftType'];
        }
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        if (requestParameters['assigned'] != null) {
            queryParameters['assigned'] = requestParameters['assigned'];
        }
        if (requestParameters['nurseProfileId'] != null) {
            queryParameters['nurseProfileId'] = requestParameters['nurseProfileId'];
        }
        if (requestParameters['facilityId'] != null) {
            queryParameters['facilityId'] = requestParameters['facilityId'];
        }
        if (requestParameters['specialtyCode'] != null) {
            queryParameters['specialtyCode'] = requestParameters['specialtyCode'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PaginatedResponseOfShiftListItemDtoFromJSON)(jsonValue));
    }
    /**
     * List shifts for admin overview or a nurse portfolio, with date/status/specialty filters
     */
    async shiftControllerListShifts(requestParameters = {}, initOverrides) {
        const response = await this.shiftControllerListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send a facility-initiated direct request inviting a specific nurse to work a shift
     */
    async shiftControllerRequestNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerRequestNurse().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerRequestNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}/request`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send a facility-initiated direct request inviting a specific nurse to work a shift
     */
    async shiftControllerRequestNurse(requestParameters, initOverrides) {
        await this.shiftControllerRequestNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Submit a nurse-initiated request to work a direct-request shift
     */
    async shiftControllerRequestShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerRequestShift().');
        }
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftControllerRequestShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/nurse/{profileId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit a nurse-initiated request to work a direct-request shift
     */
    async shiftControllerRequestShift(requestParameters, initOverrides) {
        await this.shiftControllerRequestShiftRaw(requestParameters, initOverrides);
    }
    /**
     * Submit clock-in/clock-out time entries for a completed shift to calculate hours worked
     */
    async shiftControllerSubmitTimeWorkedRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerSubmitTimeWorked().');
        }
        if (requestParameters['submitTimeWorkedDto'] == null) {
            throw new runtime.RequiredError('submitTimeWorkedDto', 'Required parameter "submitTimeWorkedDto" was null or undefined when calling shiftControllerSubmitTimeWorked().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/time-worked`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SubmitTimeWorkedDtoToJSON)(requestParameters['submitTimeWorkedDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftTimeWorkedDtoFromJSON));
    }
    /**
     * Submit clock-in/clock-out time entries for a completed shift to calculate hours worked
     */
    async shiftControllerSubmitTimeWorked(requestParameters, initOverrides) {
        const response = await this.shiftControllerSubmitTimeWorkedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update shift details such as schedule, rate, specialty, or searchability for a facility-owned shift
     */
    async shiftControllerUpdateShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerUpdateShift().');
        }
        if (requestParameters['shiftUpdateDto'] == null) {
            throw new runtime.RequiredError('shiftUpdateDto', 'Required parameter "shiftUpdateDto" was null or undefined when calling shiftControllerUpdateShift().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftUpdateDtoToJSON)(requestParameters['shiftUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     * Update shift details such as schedule, rate, specialty, or searchability for a facility-owned shift
     */
    async shiftControllerUpdateShift(requestParameters, initOverrides) {
        const response = await this.shiftControllerUpdateShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get full shift details including facility, assigned nurse, requests, and time worked
     */
    async shiftControllerViewShiftRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftControllerViewShift().');
        }
        const queryParameters = {};
        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDetailsDtoFromJSON)(jsonValue));
    }
    /**
     * Get full shift details including facility, assigned nurse, requests, and time worked
     */
    async shiftControllerViewShift(requestParameters, initOverrides) {
        const response = await this.shiftControllerViewShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all unnotified shift matches grouped by nurse profile for batch notification processing
     */
    async shiftMatchControllerFindAllShiftMatchesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ProfileShiftMatchesDtoFromJSON));
    }
    /**
     * Get all unnotified shift matches grouped by nurse profile for batch notification processing
     */
    async shiftMatchControllerFindAllShiftMatches(initOverrides) {
        const response = await this.shiftMatchControllerFindAllShiftMatchesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Send a notification to a nurse about their available matching shifts
     */
    async shiftMatchControllerNotifyProfileOfShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling shiftMatchControllerNotifyProfileOfShiftMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches/profile/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send a notification to a nurse about their available matching shifts
     */
    async shiftMatchControllerNotifyProfileOfShiftMatches(requestParameters, initOverrides) {
        await this.shiftMatchControllerNotifyProfileOfShiftMatchesRaw(requestParameters, initOverrides);
    }
    /**
     * Broadcast a reminder email and SMS to every nurse currently matched to an unclaimed shift, or to a specific subset when profileIds is provided
     */
    async shiftMatchControllerNotifyShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftMatchControllerNotifyShiftMatches().');
        }
        const queryParameters = {};
        if (requestParameters['profileIds'] != null) {
            queryParameters['profileIds'] = requestParameters['profileIds'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches/shift/{shiftId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Broadcast a reminder email and SMS to every nurse currently matched to an unclaimed shift, or to a specific subset when profileIds is provided
     */
    async shiftMatchControllerNotifyShiftMatches(requestParameters, initOverrides) {
        await this.shiftMatchControllerNotifyShiftMatchesRaw(requestParameters, initOverrides);
    }
    /**
     * Record which qualified nurses match a shift based on availability, credentials, and specialty
     */
    async shiftMatchControllerRecordShiftMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['recordShiftMatchesDto'] == null) {
            throw new runtime.RequiredError('recordShiftMatchesDto', 'Required parameter "recordShiftMatchesDto" was null or undefined when calling shiftMatchControllerRecordShiftMatches().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-matches`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.RecordShiftMatchesDtoToJSON)(requestParameters['recordShiftMatchesDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Record which qualified nurses match a shift based on availability, credentials, and specialty
     */
    async shiftMatchControllerRecordShiftMatches(requestParameters, initOverrides) {
        await this.shiftMatchControllerRecordShiftMatchesRaw(requestParameters, initOverrides);
    }
    /**
     * Accept an existing shift proposal
     */
    async shiftProposalControllerAcceptProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalAcceptDto'] == null) {
            throw new runtime.RequiredError('shiftProposalAcceptDto', 'Required parameter "shiftProposalAcceptDto" was null or undefined when calling shiftProposalControllerAcceptProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals/accept`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalAcceptDtoToJSON)(requestParameters['shiftProposalAcceptDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Accept an existing shift proposal
     */
    async shiftProposalControllerAcceptProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerAcceptProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel an existing shift proposal
     */
    async shiftProposalControllerCancelProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalCancelDto'] == null) {
            throw new runtime.RequiredError('shiftProposalCancelDto', 'Required parameter "shiftProposalCancelDto" was null or undefined when calling shiftProposalControllerCancelProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalCancelDtoToJSON)(requestParameters['shiftProposalCancelDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Cancel an existing shift proposal
     */
    async shiftProposalControllerCancelProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerCancelProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new shift proposal
     */
    async shiftProposalControllerCreateProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalCreateDto'] == null) {
            throw new runtime.RequiredError('shiftProposalCreateDto', 'Required parameter "shiftProposalCreateDto" was null or undefined when calling shiftProposalControllerCreateProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalCreateDtoToJSON)(requestParameters['shiftProposalCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Create a new shift proposal
     */
    async shiftProposalControllerCreateProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerCreateProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Reject an existing shift proposal
     */
    async shiftProposalControllerRejectProposalRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftProposalRejectDto'] == null) {
            throw new runtime.RequiredError('shiftProposalRejectDto', 'Required parameter "shiftProposalRejectDto" was null or undefined when calling shiftProposalControllerRejectProposal().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-proposals/reject`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftProposalRejectDtoToJSON)(requestParameters['shiftProposalRejectDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftProposalDtoFromJSON)(jsonValue));
    }
    /**
     * Reject an existing shift proposal
     */
    async shiftProposalControllerRejectProposal(requestParameters, initOverrides) {
        const response = await this.shiftProposalControllerRejectProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the nurse\'s ratings of a facility after a completed shift
     */
    async shiftRatingControllerGetFacilityRatingsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerGetFacilityRatings().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/facility`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     * Get the nurse\'s ratings of a facility after a completed shift
     */
    async shiftRatingControllerGetFacilityRatings(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerGetFacilityRatingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the facility\'s ratings of a nurse after a completed shift
     */
    async shiftRatingControllerGetNurseRatingsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerGetNurseRatings().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/nurse`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     * Get the facility\'s ratings of a nurse after a completed shift
     */
    async shiftRatingControllerGetNurseRatings(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerGetNurseRatingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Rate a facility on metrics like environment and staff after a completed shift
     */
    async shiftRatingControllerRateFacilityRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerRateFacility().');
        }
        if (requestParameters['shiftRatingCreateDto'] == null) {
            throw new runtime.RequiredError('shiftRatingCreateDto', 'Required parameter "shiftRatingCreateDto" was null or undefined when calling shiftRatingControllerRateFacility().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/facility`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftRatingCreateDtoToJSON)(requestParameters['shiftRatingCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     * Rate a facility on metrics like environment and staff after a completed shift
     */
    async shiftRatingControllerRateFacility(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerRateFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Rate a nurse on performance metrics after a completed shift (facility members only)
     */
    async shiftRatingControllerRateNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling shiftRatingControllerRateNurse().');
        }
        if (requestParameters['shiftRatingCreateDto'] == null) {
            throw new runtime.RequiredError('shiftRatingCreateDto', 'Required parameter "shiftRatingCreateDto" was null or undefined when calling shiftRatingControllerRateNurse().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating/{shiftId}/nurse`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftRatingCreateDtoToJSON)(requestParameters['shiftRatingCreateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ShiftRatingDtoFromJSON));
    }
    /**
     * Rate a nurse on performance metrics after a completed shift (facility members only)
     */
    async shiftRatingControllerRateNurse(requestParameters, initOverrides) {
        const response = await this.shiftRatingControllerRateNurseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the survey questions facilities use to rate nurses after a shift
     */
    async shiftRatingMetricControllerGetFacilityMetricsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating-metric/facility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftRatingMetricQuestionsDtoFromJSON)(jsonValue));
    }
    /**
     * Get the survey questions facilities use to rate nurses after a shift
     */
    async shiftRatingMetricControllerGetFacilityMetrics(initOverrides) {
        const response = await this.shiftRatingMetricControllerGetFacilityMetricsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get the survey questions nurses use to rate facilities after a shift
     */
    async shiftRatingMetricControllerGetNurseMetricsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-rating-metric/nurse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftRatingMetricQuestionsDtoFromJSON)(jsonValue));
    }
    /**
     * Get the survey questions nurses use to rate facilities after a shift
     */
    async shiftRatingMetricControllerGetNurseMetrics(initOverrides) {
        const response = await this.shiftRatingMetricControllerGetNurseMetricsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Remove a specialty qualification from a nurse profile
     */
    async specialtyControllerDeleteProfileSpecialtyRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerDeleteProfileSpecialty().');
        }
        if (requestParameters['specialtyCode'] == null) {
            throw new runtime.RequiredError('specialtyCode', 'Required parameter "specialtyCode" was null or undefined when calling specialtyControllerDeleteProfileSpecialty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}/{specialtyCode}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"specialtyCode"}}`, encodeURIComponent(String(requestParameters['specialtyCode']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a specialty qualification from a nurse profile
     */
    async specialtyControllerDeleteProfileSpecialty(requestParameters, initOverrides) {
        await this.specialtyControllerDeleteProfileSpecialtyRaw(requestParameters, initOverrides);
    }
    /**
     * Get active specialties not yet assigned to a nurse (available to add)
     */
    async specialtyControllerGetAssignableProfileSpecialtiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerGetAssignableProfileSpecialties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}/assignable`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.SpecialtyDtoFromJSON));
    }
    /**
     * Get active specialties not yet assigned to a nurse (available to add)
     */
    async specialtyControllerGetAssignableProfileSpecialties(requestParameters, initOverrides) {
        const response = await this.specialtyControllerGetAssignableProfileSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get specialties a nurse is qualified for with assessment and certification status
     */
    async specialtyControllerGetProfileSpecialtiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerGetProfileSpecialties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseSpecialtyDtoFromJSON));
    }
    /**
     * Get specialties a nurse is qualified for with assessment and certification status
     */
    async specialtyControllerGetProfileSpecialties(requestParameters, initOverrides) {
        const response = await this.specialtyControllerGetProfileSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all specialty definitions, optionally including inactive ones
     */
    async specialtyControllerGetSpecialtiesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.SpecialtyDtoFromJSON));
    }
    /**
     * Get all specialty definitions, optionally including inactive ones
     */
    async specialtyControllerGetSpecialties(requestParameters = {}, initOverrides) {
        const response = await this.specialtyControllerGetSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add specialties to a nurse and assign required Relias assessments automatically
     */
    async specialtyControllerUpdateProfileSpecialtiesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling specialtyControllerUpdateProfileSpecialties().');
        }
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling specialtyControllerUpdateProfileSpecialties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.NurseSpecialtyDtoFromJSON));
    }
    /**
     * Add specialties to a nurse and assign required Relias assessments automatically
     */
    async specialtyControllerUpdateProfileSpecialties(requestParameters, initOverrides) {
        const response = await this.specialtyControllerUpdateProfileSpecialtiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create or update a specialty definition with linked Relias assessment IDs
     */
    async specialtyControllerUpdateSpecialtyRaw(requestParameters, initOverrides) {
        if (requestParameters['specialtyUpdateDto'] == null) {
            throw new runtime.RequiredError('specialtyUpdateDto', 'Required parameter "specialtyUpdateDto" was null or undefined when calling specialtyControllerUpdateSpecialty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/specialty`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SpecialtyUpdateDtoToJSON)(requestParameters['specialtyUpdateDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.SpecialtyDtoFromJSON)(jsonValue));
    }
    /**
     * Create or update a specialty definition with linked Relias assessment IDs
     */
    async specialtyControllerUpdateSpecialty(requestParameters, initOverrides) {
        const response = await this.specialtyControllerUpdateSpecialtyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add a travel or housing stipend with a specified amount to a shift
     */
    async stipendControllerAddStipendRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling stipendControllerAddStipend().');
        }
        if (requestParameters['stipendAddDto'] == null) {
            throw new runtime.RequiredError('stipendAddDto', 'Required parameter "stipendAddDto" was null or undefined when calling stipendControllerAddStipend().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/stipend`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.StipendAddDtoToJSON)(requestParameters['stipendAddDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     * Add a travel or housing stipend with a specified amount to a shift
     */
    async stipendControllerAddStipend(requestParameters, initOverrides) {
        const response = await this.stipendControllerAddStipendRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove a stipend from a shift and return the updated shift
     */
    async stipendControllerRemoveStipendRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError('shiftId', 'Required parameter "shiftId" was null or undefined when calling stipendControllerRemoveStipend().');
        }
        if (requestParameters['stipendId'] == null) {
            throw new runtime.RequiredError('stipendId', 'Required parameter "stipendId" was null or undefined when calling stipendControllerRemoveStipend().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift/{shiftId}/stipend/{stipendId}`.replace(`{${"shiftId"}}`, encodeURIComponent(String(requestParameters['shiftId']))).replace(`{${"stipendId"}}`, encodeURIComponent(String(requestParameters['stipendId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ShiftDtoFromJSON)(jsonValue));
    }
    /**
     * Remove a stipend from a shift and return the updated shift
     */
    async stipendControllerRemoveStipend(requestParameters, initOverrides) {
        const response = await this.stipendControllerRemoveStipendRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Populate the database with test nurse and facility admin accounts for local development (disabled in production)
     */
    async testDataControllerGenerateTestDataRaw(requestParameters, initOverrides) {
        if (requestParameters['createTestDataDto'] == null) {
            throw new runtime.RequiredError('createTestDataDto', 'Required parameter "createTestDataDto" was null or undefined when calling testDataControllerGenerateTestData().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/test-data/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.CreateTestDataDtoToJSON)(requestParameters['createTestDataDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.TestDataAvatarsDtoFromJSON)(jsonValue));
    }
    /**
     * Populate the database with test nurse and facility admin accounts for local development (disabled in production)
     */
    async testDataControllerGenerateTestData(requestParameters, initOverrides) {
        const response = await this.testDataControllerGenerateTestDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List nurse profile IDs to remind for the previous pay period: unsubmitted timecards, or every nurse with a shift for the paycheck preview
     */
    async timecardReminderControllerGetOutstandingProfilesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['reminderType'] != null) {
            queryParameters['reminderType'] = requestParameters['reminderType'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/timecard-reminder/outstanding-profiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List nurse profile IDs to remind for the previous pay period: unsubmitted timecards, or every nurse with a shift for the paycheck preview
     */
    async timecardReminderControllerGetOutstandingProfiles(requestParameters = {}, initOverrides) {
        const response = await this.timecardReminderControllerGetOutstandingProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send a nurse a weekly timecard reminder (advance or cutoff) or the paycheck preview for the previous pay period
     */
    async timecardReminderControllerNotifyNurseRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling timecardReminderControllerNotifyNurse().');
        }
        if (requestParameters['reminderType'] == null) {
            throw new runtime.RequiredError('reminderType', 'Required parameter "reminderType" was null or undefined when calling timecardReminderControllerNotifyNurse().');
        }
        const queryParameters = {};
        if (requestParameters['reminderType'] != null) {
            queryParameters['reminderType'] = requestParameters['reminderType'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/timecard-reminder/notify/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send a nurse a weekly timecard reminder (advance or cutoff) or the paycheck preview for the previous pay period
     */
    async timecardReminderControllerNotifyNurse(requestParameters, initOverrides) {
        await this.timecardReminderControllerNotifyNurseRaw(requestParameters, initOverrides);
    }
    /**
     * Get active TB screening symptom questions and work history questions
     */
    async tuberculosisScreeningControllerGetQuestionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tuberculosis-screening`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.TuberculosisScreeningDtoFromJSON)(jsonValue));
    }
    /**
     * Get active TB screening symptom questions and work history questions
     */
    async tuberculosisScreeningControllerGetQuestions(initOverrides) {
        const response = await this.tuberculosisScreeningControllerGetQuestionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get a nurse\'s completed TB screening responses and symptom answers
     */
    async tuberculosisScreeningControllerGetResponsesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling tuberculosisScreeningControllerGetResponses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tuberculosis-screening/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.TuberculosisScreeningDtoFromJSON)(jsonValue));
    }
    /**
     * Get a nurse\'s completed TB screening responses and symptom answers
     */
    async tuberculosisScreeningControllerGetResponses(requestParameters, initOverrides) {
        const response = await this.tuberculosisScreeningControllerGetResponsesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Submit a nurse\'s TB screening symptom and work history responses (requires valid Mantoux/QuantiFERON test)
     */
    async tuberculosisScreeningControllerSubmitResponsesRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling tuberculosisScreeningControllerSubmitResponses().');
        }
        if (requestParameters['tuberculosisScreeningCreateDto'] == null) {
            throw new runtime.RequiredError('tuberculosisScreeningCreateDto', 'Required parameter "tuberculosisScreeningCreateDto" was null or undefined when calling tuberculosisScreeningControllerSubmitResponses().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tuberculosis-screening/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.TuberculosisScreeningCreateDtoToJSON)(requestParameters['tuberculosisScreeningCreateDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit a nurse\'s TB screening symptom and work history responses (requires valid Mantoux/QuantiFERON test)
     */
    async tuberculosisScreeningControllerSubmitResponses(requestParameters, initOverrides) {
        await this.tuberculosisScreeningControllerSubmitResponsesRaw(requestParameters, initOverrides);
    }
    /**
     * Process Typeform signup form submission and auto-invite new nurses to the platform
     */
    async typeformControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters['typeformPayloadDto'] == null) {
            throw new runtime.RequiredError('typeformPayloadDto', 'Required parameter "typeformPayloadDto" was null or undefined when calling typeformControllerHandleHubSpotWebhook().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/typeform/signup-form/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.TypeformPayloadDtoToJSON)(requestParameters['typeformPayloadDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Typeform signup form submission and auto-invite new nurses to the platform
     */
    async typeformControllerHandleHubSpotWebhook(requestParameters, initOverrides) {
        await this.typeformControllerHandleHubSpotWebhookRaw(requestParameters, initOverrides);
    }
    /**
     * Remove a vaccination card document from the record and delete it from storage
     */
    async vaccinationControllerDeleteVaccinationDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerDeleteVaccinationDocument().');
        }
        if (requestParameters['vaccinationId'] == null) {
            throw new runtime.RequiredError('vaccinationId', 'Required parameter "vaccinationId" was null or undefined when calling vaccinationControllerDeleteVaccinationDocument().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{vaccinationId}/vaccine-card`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"vaccinationId"}}`, encodeURIComponent(String(requestParameters['vaccinationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a vaccination card document from the record and delete it from storage
     */
    async vaccinationControllerDeleteVaccinationDocument(requestParameters, initOverrides) {
        await this.vaccinationControllerDeleteVaccinationDocumentRaw(requestParameters, initOverrides);
    }
    /**
     * Get a single vaccination record by type (e.g. COVID-19, influenza, hepatitis) with document URL
     */
    async vaccinationControllerGetVaccinationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerGetVaccination().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling vaccinationControllerGetVaccination().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{code}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccinationDtoFromJSON)(jsonValue));
    }
    /**
     * Get a single vaccination record by type (e.g. COVID-19, influenza, hepatitis) with document URL
     */
    async vaccinationControllerGetVaccination(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerGetVaccinationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the COVID-19 or influenza declination agreement form for a nurse to review
     */
    async vaccinationControllerGetVaccinationDeclinationAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerGetVaccinationDeclinationAgreement().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling vaccinationControllerGetVaccinationDeclinationAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{code}/declination`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccineDeclinationDtoFromJSON)(jsonValue));
    }
    /**
     * Get the COVID-19 or influenza declination agreement form for a nurse to review
     */
    async vaccinationControllerGetVaccinationDeclinationAgreement(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerGetVaccinationDeclinationAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all vaccination records for a nurse including dose history and card documents
     */
    async vaccinationControllerGetVaccinationsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerGetVaccinations().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.VaccinationDtoFromJSON));
    }
    /**
     * Get all vaccination records for a nurse including dose history and card documents
     */
    async vaccinationControllerGetVaccinations(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerGetVaccinationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload a vaccination document and use AI to extract dose and manufacturer data
     */
    async vaccinationControllerIngestVaccinationDocumentationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerIngestVaccinationDocumentation().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document']);
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/ingest`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.IngestedVaccinationRecordsDtoFromJSON)(jsonValue));
    }
    /**
     * Upload a vaccination document and use AI to extract dose and manufacturer data
     */
    async vaccinationControllerIngestVaccinationDocumentation(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerIngestVaccinationDocumentationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Sign a COVID-19 or influenza declination with reasons and signature
     */
    async vaccinationControllerSignVaccinationDeclinationAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerSignVaccinationDeclinationAgreement().');
        }
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError('code', 'Required parameter "code" was null or undefined when calling vaccinationControllerSignVaccinationDeclinationAgreement().');
        }
        if (requestParameters['signVaccineDeclinationAgreementDto'] == null) {
            throw new runtime.RequiredError('signVaccineDeclinationAgreementDto', 'Required parameter "signVaccineDeclinationAgreementDto" was null or undefined when calling vaccinationControllerSignVaccinationDeclinationAgreement().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{code}/declination`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.SignVaccineDeclinationAgreementDtoToJSON)(requestParameters['signVaccineDeclinationAgreementDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccineDeclinationDtoFromJSON)(jsonValue));
    }
    /**
     * Sign a COVID-19 or influenza declination with reasons and signature
     */
    async vaccinationControllerSignVaccinationDeclinationAgreement(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerSignVaccinationDeclinationAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Submit or update vaccination doses with date and manufacturer details
     */
    async vaccinationControllerUpdateVaccinationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerUpdateVaccination().');
        }
        if (requestParameters['vaccinationDto'] == null) {
            throw new runtime.RequiredError('vaccinationDto', 'Required parameter "vaccinationDto" was null or undefined when calling vaccinationControllerUpdateVaccination().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/vaccination/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.VaccinationDtoToJSON)(requestParameters['vaccinationDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.VaccinationDtoFromJSON)(jsonValue));
    }
    /**
     * Submit or update vaccination doses with date and manufacturer details
     */
    async vaccinationControllerUpdateVaccination(requestParameters, initOverrides) {
        const response = await this.vaccinationControllerUpdateVaccinationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload a photo or PDF of a vaccination card for credential verification
     */
    async vaccinationControllerUploadVaccinationCardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling vaccinationControllerUploadVaccinationCard().');
        }
        if (requestParameters['vaccinationId'] == null) {
            throw new runtime.RequiredError('vaccinationId', 'Required parameter "vaccinationId" was null or undefined when calling vaccinationControllerUploadVaccinationCard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['vaccineCard'] != null) {
            formParams.append('vaccineCard', requestParameters['vaccineCard']);
        }
        const response = await this.request({
            path: `/vaccination/{profileId}/{vaccinationId}/vaccine-card`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))).replace(`{${"vaccinationId"}}`, encodeURIComponent(String(requestParameters['vaccinationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload a photo or PDF of a vaccination card for credential verification
     */
    async vaccinationControllerUploadVaccinationCard(requestParameters, initOverrides) {
        await this.vaccinationControllerUploadVaccinationCardRaw(requestParameters, initOverrides);
    }
    /**
     * Process Checkr webhook events for background check reports, invitations, and package changes
     */
    async webhookControllerHandleCheckrWebhookRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/background-check/webhook/checkr`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Checkr webhook events for background check reports, invitations, and package changes
     */
    async webhookControllerHandleCheckrWebhook(initOverrides) {
        await this.webhookControllerHandleCheckrWebhookRaw(initOverrides);
    }
    /**
     * Process KarmaCheck webhook events for background check case status changes
     */
    async webhookControllerHandleKarmaCheckWebhookRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/background-check/webhook/karmacheck`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process KarmaCheck webhook events for background check case status changes
     */
    async webhookControllerHandleKarmaCheckWebhook(initOverrides) {
        await this.webhookControllerHandleKarmaCheckWebhookRaw(initOverrides);
    }
    /**
     * Process Twilio SMS webhook to handle carrier opt-in/opt-out (START/STOP) for nurse phone numbers
     */
    async webhookControllerIncomingMessageRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/sms/webhook/incoming`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Process Twilio SMS webhook to handle carrier opt-in/opt-out (START/STOP) for nurse phone numbers
     */
    async webhookControllerIncomingMessage(initOverrides) {
        await this.webhookControllerIncomingMessageRaw(initOverrides);
    }
    /**
     * Validate whether a nurse meets all credential requirements to attend orientation shifts
     */
    async workQualificationControllerGetOrientationQualificationsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftCandidatesDto'] == null) {
            throw new runtime.RequiredError('shiftCandidatesDto', 'Required parameter "shiftCandidatesDto" was null or undefined when calling workQualificationControllerGetOrientationQualifications().');
        }
        const queryParameters = {};
        if (requestParameters['nurseProfileId'] != null) {
            queryParameters['nurseProfileId'] = requestParameters['nurseProfileId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/work-qualification/orientation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCandidatesDtoToJSON)(requestParameters['shiftCandidatesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkQualificationResultDtoFromJSON)(jsonValue));
    }
    /**
     * Validate whether a nurse meets all credential requirements to attend orientation shifts
     */
    async workQualificationControllerGetOrientationQualifications(requestParameters, initOverrides) {
        const response = await this.workQualificationControllerGetOrientationQualificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Validate whether a nurse meets all credential requirements to work candidate shifts
     */
    async workQualificationControllerGetShiftQualificationsRaw(requestParameters, initOverrides) {
        if (requestParameters['shiftCandidatesDto'] == null) {
            throw new runtime.RequiredError('shiftCandidatesDto', 'Required parameter "shiftCandidatesDto" was null or undefined when calling workQualificationControllerGetShiftQualifications().');
        }
        const queryParameters = {};
        if (requestParameters['nurseProfileId'] != null) {
            queryParameters['nurseProfileId'] = requestParameters['nurseProfileId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/work-qualification/shift`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, index_1.ShiftCandidatesDtoToJSON)(requestParameters['shiftCandidatesDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkQualificationResultDtoFromJSON)(jsonValue));
    }
    /**
     * Validate whether a nurse meets all credential requirements to work candidate shifts
     */
    async workQualificationControllerGetShiftQualifications(requestParameters, initOverrides) {
        const response = await this.workQualificationControllerGetShiftQualificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.DefaultApi = DefaultApi;
/**
 * @export
 */
exports.DocumentAuditControllerListStatusEnum = {
    NeedsReview: 'NEEDS_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
};
/**
 * @export
 */
exports.DocumentAuditControllerListDocumentTypeEnum = {
    AdminChatAttachment: 'ADMIN_CHAT_ATTACHMENT',
    Certification: 'CERTIFICATION',
    DhsClearanceLetter: 'DHS_CLEARANCE_LETTER',
    DhsRegistryCheckResult: 'DHS_REGISTRY_CHECK_RESULT',
    Orientation: 'ORIENTATION',
    Vaccination: 'VACCINATION'
};
/**
 * @export
 */
exports.DocumentAuditControllerListLlmDecisionEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Error: 'ERROR',
    None: 'NONE'
};
/**
 * @export
 */
exports.FacilityControllerGetFacilitiesSortEnum = {
    NameAsc: 'name:asc',
    NameDesc: 'name:desc',
    Name: 'name',
    ActiveAsc: 'active:asc',
    ActiveDesc: 'active:desc',
    Active: 'active',
    InterestCountAsc: 'interestCount:asc',
    InterestCountDesc: 'interestCount:desc',
    InterestCount: 'interestCount'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsStatusEnum = {
    Open: 'open',
    Upcoming: 'upcoming',
    Complete: 'complete',
    Canceled: 'canceled',
    All: 'all'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsShiftTimesEnum = {
    Days06001830: 'DAYS_0600_1830',
    Days07001100: 'DAYS_0700_1100',
    Days07001530: 'DAYS_0700_1530',
    Days07001930: 'DAYS_0700_1930',
    Days11001500: 'DAYS_1100_1500',
    Eves15001900: 'EVES_1500_1900',
    Eves15002330: 'EVES_1500_2330',
    Eves19002300: 'EVES_1900_2300',
    Nights03000700: 'NIGHTS_0300_0700',
    Nights18000630: 'NIGHTS_1800_0630',
    Nights19000730: 'NIGHTS_1900_0730',
    Nights23000300: 'NIGHTS_2300_0300',
    Nights23000730: 'NIGHTS_2300_0730',
    Custom: 'CUSTOM'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsShiftTypeEnum = {
    Clinical: 'CLINICAL',
    Orientation: 'ORIENTATION',
    OnCall: 'ON_CALL'
};
/**
 * @export
 */
exports.FacilityControllerListShiftsSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime',
    EndTimeAsc: 'endTime:asc',
    EndTimeDesc: 'endTime:desc',
    EndTime: 'endTime',
    LicenseTypeAsc: 'licenseType:asc',
    LicenseTypeDesc: 'licenseType:desc',
    LicenseType: 'licenseType',
    NurseProfileAsc: 'nurseProfile:asc',
    NurseProfileDesc: 'nurseProfile:desc',
    NurseProfile: 'nurseProfile',
    ShiftTimeAsc: 'shiftTime:asc',
    ShiftTimeDesc: 'shiftTime:desc',
    ShiftTime: 'shiftTime',
    PostedByAsc: 'postedBy:asc',
    PostedByDesc: 'postedBy:desc',
    PostedBy: 'postedBy',
    SpecialtyAsc: 'specialty:asc',
    SpecialtyDesc: 'specialty:desc',
    Specialty: 'specialty',
    CreatedAtAsc: 'createdAt:asc',
    CreatedAtDesc: 'createdAt:desc',
    CreatedAt: 'createdAt'
};
/**
 * @export
 */
exports.FacilityControllerShiftCalendarSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.NurseControllerListShiftsSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.OrientationOpportunityControllerListOrientationOpportunitiesSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime',
    LicenseTypeAsc: 'licenseType:asc',
    LicenseTypeDesc: 'licenseType:desc',
    LicenseType: 'licenseType',
    SpecialtyCodeAsc: 'specialtyCode:asc',
    SpecialtyCodeDesc: 'specialtyCode:desc',
    SpecialtyCode: 'specialtyCode',
    TotalRateAsc: 'totalRate:asc',
    TotalRateDesc: 'totalRate:desc',
    TotalRate: 'totalRate',
    CreatedAtAsc: 'createdAt:asc',
    CreatedAtDesc: 'createdAt:desc',
    CreatedAt: 'createdAt'
};
/**
 * @export
 */
exports.PayrollControllerGetPaychecksStatusEnum = {
    Pending: 'PENDING',
    Preprocessed: 'PREPROCESSED',
    Processed: 'PROCESSED',
    Voided: 'VOIDED',
    Failed: 'FAILED'
};
/**
 * @export
 */
exports.ProfileControllerListProfilesFilterModeEnum = {
    All: 'all',
    Any: 'any'
};
/**
 * @export
 */
exports.ProfileControllerListProfilesSortEnum = {
    IdAsc: 'id:asc',
    IdDesc: 'id:desc',
    Id: 'id',
    FirstNameAsc: 'firstName:asc',
    FirstNameDesc: 'firstName:desc',
    FirstName: 'firstName',
    LastNameAsc: 'lastName:asc',
    LastNameDesc: 'lastName:desc',
    LastName: 'lastName',
    EmailAsc: 'email:asc',
    EmailDesc: 'email:desc',
    Email: 'email',
    HomeStateAsc: 'homeState:asc',
    HomeStateDesc: 'homeState:desc',
    HomeState: 'homeState',
    CreatedAtAsc: 'createdAt:asc',
    CreatedAtDesc: 'createdAt:desc',
    CreatedAt: 'createdAt'
};
/**
 * @export
 */
exports.SearchControllerFindAvailableOrientationOpportunitiesSortEnum = {
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.SearchControllerFindAvailableShiftsSortEnum = {
    PayRateAsc: 'payRate:asc',
    PayRateDesc: 'payRate:desc',
    PayRate: 'payRate',
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime'
};
/**
 * @export
 */
exports.ShiftControllerListShiftsStatusEnum = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
exports.ShiftControllerListShiftsShiftTypeEnum = {
    Clinical: 'CLINICAL',
    Orientation: 'ORIENTATION',
    OnCall: 'ON_CALL'
};
/**
 * @export
 */
exports.ShiftControllerListShiftsSortEnum = {
    FacilityAsc: 'facility:asc',
    FacilityDesc: 'facility:desc',
    Facility: 'facility',
    NurseProfileAsc: 'nurseProfile:asc',
    NurseProfileDesc: 'nurseProfile:desc',
    NurseProfile: 'nurseProfile',
    StartTimeAsc: 'startTime:asc',
    StartTimeDesc: 'startTime:desc',
    StartTime: 'startTime',
    SpecialtyCodeAsc: 'specialtyCode:asc',
    SpecialtyCodeDesc: 'specialtyCode:desc',
    SpecialtyCode: 'specialtyCode',
    StatusAsc: 'status:asc',
    StatusDesc: 'status:desc',
    Status: 'status',
    TotalRateAsc: 'totalRate:asc',
    TotalRateDesc: 'totalRate:desc',
    TotalRate: 'totalRate'
};
//# sourceMappingURL=DefaultApi.js.map